(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edg-adapter-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  const $=(r,s)=>r.querySelector(s), $$=(r,s)=>Array.from(r.querySelectorAll(s));
  const guided=()=>new URLSearchParams(location.search||'').get('edg_guided')==='1';
  const show=(el,yes)=>{if(el)el.hidden=!yes;};
  const text=(r,s,v)=>{const e=$(r,s);if(e)e.textContent=v||'';};
  function native(h){const s='[data-option-name="'+h+'"]';return document.querySelector('.variant-selects-main '+s)||document.querySelector(s)}
  function apply(h,v){const c=native(h);if(!c)return false;const radio=Array.from(c.querySelectorAll('input[type="radio"]')).find(x=>x.value===v);if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));return true}const sel=c.querySelector('select');if(!sel)return false;const i=Array.from(sel.options).findIndex(o=>o.value===v||o.textContent.trim()===v);if(i<0)return false;sel.selectedIndex=i;sel.dispatchEvent(new Event('change',{bubbles:true}));return true}
  function selected(h){const c=native(h);if(!c)return'';const r=c.querySelector('input[type="radio"]:checked');if(r)return r.value;const s=c.querySelector('select');return s?s.value:''}
  function variantId(root){const fs=Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(f=>!root.contains(f));const f=fs.find(x=>(x.getAttribute('id')||'').indexOf('product-form-')===0&&x.querySelector('input[name="id"]'))||fs.find(x=>x.querySelector('input[name="id"]'));const i=f&&f.querySelector('input[name="id"]');return i&&i.value?Number(i.value):null}
  function status(root,msg,state){const e=$(root,'[data-status]');if(!e)return;e.textContent=msg||'';if(state)e.dataset.state=state;else delete e.dataset.state}
  function select(button,container,selector){$$(container,selector).forEach(x=>{const y=x===button;x.classList.toggle('is-selected',y);x.setAttribute('aria-pressed',y?'true':'false')})}
  function step(root,key,state){const e=$(root,'[data-step="'+key+'"]');if(!e)return;e.classList.remove('is-active','is-complete','is-locked');e.classList.add('is-'+state);const h=$(e,'[data-edit-step]');if(h){h.disabled=state==='locked';h.setAttribute('aria-expanded',state==='active'?'true':'false')}const p=$(root,'[data-progress="'+key+'"]');if(p){p.classList.toggle('is-active',state==='active');p.classList.toggle('is-complete',state==='complete')}}
  function compact(root){return root.dataset.family==='fi3-compact'||root.dataset.family==='mini-compact'}
  function activate(root,key){const order=root.dataset.family==='fi3-compact'?['series','width','hardware','review']:compact(root)?['width','hardware','review']:['placement','width','hardware','review'],i=order.indexOf(key);order.forEach((n,x)=>step(root,n,x<i?'complete':x===i?'active':'locked'))}
  function block(root,title,copy,actions){show($(root,'[data-build-flow]'),false);show($(root,'[data-blocked]'),true);text(root,'[data-blocked-title]',title);text(root,'[data-blocked-copy]',copy);const a=$(root,'[data-blocked-actions]');if(a)a.innerHTML=actions||'<button type="button" data-back>Back to choices</button>';const b=$(root,'[data-back]');if(b)b.addEventListener('click',()=>history.back())}
  function compatible(root,dog){const fam=root.dataset.family,series=dog&&dog.fiStatus==='yes'?dog.fiSeries:'';
    if(fam==='mini-compact'&&series&&series!=='Fi Mini'){block(root,'This adapter is specifically for Fi Mini.','Your saved setup uses '+series+', so this product is not the verified adapter path.');return false}
    if(fam==='fi3-behavior'&&series&&series!=='Series 3+'){block(root,'The Behavior Adapter is specifically for Fi 3+.','Your saved setup uses '+series+'. Use the Compact Adapter for Fi Series 2 or Series 3.');return false}
    if(fam==='fi3-behavior'&&dog&&dog.wear==='harness'&&dog.harnessChoice==='harness-only'){block(root,'Behavior Adapter is collar-only.','Your saved setup is harness-only. Use the Fi 3+ Compact Adapter for a compatible harness.','<a href="/products/fi-series-2-3-3-plus-compact-adapter?edg_guided=1">Continue to Fi 3+ Compact Adapter</a><button type="button" data-back>Back to choices</button>');return false}
    return true
  }
  function save(root,session){if(!session||!session.patchActiveDog)return;session.patchActiveDog({adapter:{family:root.dataset.family||'',placement:root.dataset.placement||'',strapWidth:root.dataset.widthValue||'',hardware:root.dataset.hardwareValue||''}});if(session.saveBuild)session.saveBuild('adapter',{family:root.dataset.family||'',productHandle:root.dataset.productHandle||'',placement:root.dataset.placement||'',strapWidth:root.dataset.widthValue||'',hardware:root.dataset.hardwareValue||'',guided:guided()})}
  function review(root,dog){text(root,'[data-review-dog]',dog&&dog.name?dog.name:'Your dog');text(root,'[data-review-fi]',root.dataset.seriesValue?root.dataset.seriesValue:dog&&dog.fiSeries?dog.fiSeries:(root.dataset.family==='mini-compact'?'Fi Mini':'Fi 3+'));text(root,'[data-review-placement]',root.dataset.placement==='harness'?'Harness':'Collar');text(root,'[data-review-width]',root.dataset.widthValue||'');text(root,'[data-review-hardware]',root.dataset.hardwareValue||'')}
  function match(root){return (root.dataset.family!=='fi3-compact'||(!!root.dataset.seriesValue&&selected('fi-series')===root.dataset.seriesValue))&&selected(root.dataset.widthOption||'collar-width')===(root.dataset.widthValue||'')&&selected(root.dataset.hardwareOption||'snap-type')===(root.dataset.hardwareValue||'')}
  function wait(root,t){return new Promise(resolve=>{const start=Date.now();(function c(){if(match(root)&&variantId(root))return resolve(true);if(Date.now()-start>=t)return resolve(false);setTimeout(c,100)})()})}
  async function add(root,session,dog){if(root.dataset.family==='fi3-compact'&&!root.dataset.seriesValue){activate(root,'series');status(root,'Choose your Fi tracker first.','error');return}if((!compact(root)&&!root.dataset.placement)||!root.dataset.widthValue||!root.dataset.hardwareValue){status(root,compact(root)?'Complete width and hardware before adding this adapter.':'Complete placement, width, and hardware before adding this adapter.','error');return}const b=$(root,'[data-add-build]');b.disabled=true;status(root,'Checking the selected adapter…');if(!(await wait(root,3000))){b.disabled=false;status(root,'Eurus could not confirm the exact native Shopify variant. Re-select the last choice and try again.','error');return}const id=variantId(root);if(!id){b.disabled=false;status(root,'That exact adapter combination is not currently available.','error');return}const props={'Dog name':dog&&dog.name?dog.name:'','Fi setup':root.dataset.seriesValue?root.dataset.seriesValue:dog&&dog.fiSeries?dog.fiSeries:(root.dataset.family==='mini-compact'?'Fi Mini':'Fi 3+'),'Adapter placement':root.dataset.placement==='harness'?'Harness':'Collar','Strap width':root.dataset.widthValue,'Snap hardware':root.dataset.hardwareValue,'_EDG Config Version':'guided-adapter-v1','_EDG Entry Path':'Guided selector'};if(compact(root))delete props['Adapter placement'];b.textContent='Adding adapter…';try{if(window.EDGMonthlyOpenings)Object.assign(props,window.EDGMonthlyOpenings.batchProperties('adapter',props));const base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';const res=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1,properties:props}]})});const data=await res.json();if(!res.ok)throw new Error(data.description||data.message||'Shopify could not add this adapter.');save(root,session);status(root,'Adapter added. Opening cart…');location.assign(base+'cart')}catch(e){b.disabled=false;b.textContent='Add this adapter to cart';status(root,e.message||'Something prevented this adapter from being added.','error')}}
  function init(root,session){if(root.dataset.initialized==='true')return;root.dataset.initialized='true';if(!guided()){show(root,false);return}show(root,true);document.documentElement.classList.add('edg-adapter-guided-active');const dog=session.activeDog?session.activeDog():null;if(!compatible(root,dog))return;
    const w=$(root,'[data-width-choice]'),h=$(root,'[data-hardware-choice]');root.dataset.widthOption=w?w.dataset.nativeOption:'collar-width';root.dataset.hardwareOption=h?h.dataset.nativeOption:'snap-type';
    if(native('color'))apply('color','Black');
    if(dog){const note=$(root,'[data-saved-context]');show(note,true);if(note)note.innerHTML='<strong>'+(dog.name?dog.name+'’s':'Saved')+' Fi setup:</strong> '+(dog.fiSeries||'compatible Fi')+'. We’ll finish only the adapter-specific choices here.';text(root,'[data-builder-title]',root.dataset.layoutTitle)}
    let initial='';if(root.dataset.family==='fi3-behavior')initial='collar';else if(dog&&dog.wear==='harness'&&dog.harnessChoice==='harness-only')initial='harness';else if(dog&&dog.wear==='collar')initial='collar';
    if(initial){const b=$(root,'[data-placement="'+initial+'"]');if(b){select(b,$(root,'[data-placement-choices]'),'[data-placement]');root.dataset.placement=initial;text(root,'[data-step-summary="placement"]',initial==='harness'?'Harness':'Collar');step(root,'placement','complete');step(root,'width','active')}}
    if(compact(root)){
      delete root.dataset.placement;
      show($(root,'[data-step="placement"]'),false);
      show($(root,'[data-progress="placement"]'),false);
      const placementReview=$(root,'[data-review-placement]');if(placementReview)show(placementReview.parentElement,false);
      const nav=$(root,'.edg-adapter__progress');if(nav)nav.style.gridTemplateColumns=root.dataset.family==='fi3-compact'?'repeat(4,1fr)':'repeat(3,1fr)';
      (root.dataset.family==='fi3-compact'?['series','width','hardware','review']:['width','hardware','review']).forEach((key,i)=>{
        text(root,'[data-progress="'+key+'"]',(i+1)+' '+({series:'Fi tracker',width:'Width',hardware:'Hardware',review:'Review'}[key]));
        text(root,'[data-edit-step="'+key+'"] > span:first-child','0'+(i+1));
      });
      text(root,'.edg-adapter__intro','Fits compatible collar or harness straps. Choose the strap width and hardware you prefer.');
      activate(root,root.dataset.family==='fi3-compact'?'series':'width');
    }
    if(root.dataset.family==='fi3-compact'){
      text(root,'.edg-adapter__intro','Choose your Fi tracker, strap width, and snap hardware.');
      const note=$(root,'[data-saved-context]');
      if(note){note.textContent=dog&&dog.fiSeries?'Earlier choice: '+dog.fiSeries+'. You can choose a different tracker for this adapter below.':'';show(note,!!(dog&&dog.fiSeries));}
      const miniLink=$(root,'[data-mini-tracker]');
      if(miniLink){
        const miniUrl=new URL(miniLink.href,location.href);
        const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)miniUrl.searchParams.set('preview_theme_id',preview);
        miniLink.href=miniUrl.pathname+miniUrl.search;
        miniLink.addEventListener('click',()=>{if(session.patchActiveDog)session.patchActiveDog({fiStatus:'yes',fiSeries:'Fi Mini',adapter:{family:'mini-compact',placement:'',strapWidth:'',hardware:''}});});
      }
      $$(root,'[data-series-choice]').forEach(b=>b.addEventListener('click',()=>{
        if(!apply(b.dataset.nativeOption,b.dataset.nativeValue)){status(root,'We could not apply that tracker choice. Please try again.','error');return}
        root.dataset.seriesValue=b.dataset.nativeValue;
        select(b,$(root,'[data-series-choices]'),'[data-series-choice]');
        text(root,'[data-step-summary="series"]',b.dataset.nativeValue);
        if(session.patchActiveDog)session.patchActiveDog({fiStatus:'yes',fiSeries:b.dataset.nativeValue==='Fi Series 2'?'Fi 2':(dog&&dog.fiSeries==='Series 3'?'Series 3':'Series 3+')});
        if(note)note.hidden=true;
        status(root,'');activate(root,'width');review(root,dog);save(root,session);
      }));
    }
    $$(root,'[data-placement]').forEach(b=>b.addEventListener('click',()=>{select(b,$(root,'[data-placement-choices]'),'[data-placement]');root.dataset.placement=b.dataset.placement;text(root,'[data-step-summary="placement"]',b.dataset.placement==='harness'?'Harness':'Collar');step(root,'placement','complete');step(root,'width','active');step(root,'hardware','locked');step(root,'review','locked');save(root,session)}));
    $$(root,'[data-width-choice]').forEach(b=>b.addEventListener('click',()=>{if(!apply(b.dataset.nativeOption,b.dataset.nativeValue)){status(root,'We could not apply that width to Eurus.','error');return}select(b,$(root,'[data-width-choices]'),'[data-width-choice]');root.dataset.widthValue=b.dataset.nativeValue;text(root,'[data-step-summary="width"]',b.dataset.nativeValue);step(root,'width','complete');step(root,'hardware','active');step(root,'review','locked');save(root,session)}));
    $$(root,'[data-hardware-choice]').forEach(b=>b.addEventListener('click',()=>{if(!apply(b.dataset.nativeOption,b.dataset.nativeValue)){status(root,'We could not apply that hardware option to Eurus.','error');return}select(b,$(root,'[data-hardware-choices]'),'[data-hardware-choice]');root.dataset.hardwareValue=b.dataset.nativeValue;text(root,'[data-step-summary="hardware"]',b.dataset.nativeValue);step(root,'hardware','complete');step(root,'review','active');review(root,dog);save(root,session)}));
    $$(root,'[data-edit-step]').forEach(b=>b.addEventListener('click',()=>{if(!b.disabled)activate(root,b.dataset.editStep)}));$(root,'[data-add-build]').addEventListener('click',()=>add(root,session,dog));save(root,session)
  }
  function boot(n){const root=document.querySelector('[data-edg-adapter-builder]');if(!root)return;const s=window.EDGBuildSession;if(!s){if((n||0)<50)setTimeout(()=>boot((n||0)+1),60);return}init(root,s)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(0));else boot(0);document.addEventListener('shopify:section:load',()=>boot(0));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-cart-build-review"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var scheduled=false;
  function sync(){
    scheduled=false;
    var review=document.querySelector('[data-edg-cart-build-review]');
    var main=document.getElementById('main-cart-items');
    if(!review||!main)return;
    var heading=main.querySelector('div.mb-3.mt-3.pt-1\\.5')||main.firstElementChild;
    if(heading&&review.parentElement!==main) heading.insertAdjacentElement('afterend',review);
    review.querySelectorAll('[data-edg-cart-build-item]').forEach(function(card){
      var row=document.getElementById('CartItem-'+card.dataset.cartIndex);
      card.hidden=!row;
      if(row){var nativeDetails=row.querySelector('dl.text-normal');if(nativeDetails)nativeDetails.classList.add('edg-guided-native-details');}
    });
  }
  function queue(){if(scheduled)return;scheduled=true;requestAnimationFrame(sync);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();
  document.addEventListener('shopify:section:load',sync);
  new MutationObserver(queue).observe(document.documentElement,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-collection-handoff"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var supported={'traditional-buckle-collar':1,'fi-traditional-buckle-collar':1,'martingale-collar':1,'fi-martingale-collar':1,'arctic-circle-collar':1,'fi-arctic-circle-collar':1,'fi-signature-canvas-collar':1,'fi-mini-compact-adapter':1,'fi-3-compact-adapter':1,'fi-3-behavior-adapter':1};
  function guided(){return new URLSearchParams(location.search||'').get('edg_guided')==='1';}
  function addGuided(href){if(!href||href.indexOf('/products/')<0||href.indexOf('edg_guided=1')>=0)return href;var match=href.match(/\/products\/([^/?#]+)/);if(!match||!supported[match[1]])return href;var hash='',base=href,idx=base.indexOf('#');if(idx>=0){hash=base.slice(idx);base=base.slice(0,idx);}return base+(base.indexOf('?')>=0?'&':'?')+'edg_guided=1'+hash;}
  function rewrite(root){if(!guided())return;(root||document).querySelectorAll('a[href*="/products/"]').forEach(function(link){var next=addGuided(link.getAttribute('href')||'');if(next)link.setAttribute('href',next);});var note=document.querySelector('[data-edg-collection-handoff-note]');if(note)note.hidden=false;}
  function boot(){if(!guided())return;rewrite(document);var grid=document.querySelector('#ProductGridContainer, [data-product-grid], .product-grid-container, main');if(grid&&!grid.dataset.edgGuidedObserver){grid.dataset.edgGuidedObserver='1';new MutationObserver(function(){rewrite(grid);}).observe(grid,{childList:true,subtree:true});}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-color-hero-swap"]) return;
  try {
    
(function () {
  var MAP = {
    'yellow': { label: 'Yellow', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-YEL-F3-PAD-HERO.png?v=1786303824' },
    'lime': { label: 'Lime', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-LIM-F3-PAD-HERO.png?v=1786303935' },
    'green': { label: 'Green', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-GRN-F3-PAD-HERO.png?v=1786303949' },
    'olive': { label: 'Olive', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-OLV-F3-PAD-HERO.png?v=1786303958' },
    'hunter green': { label: 'Hunter Green', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-HGR-F3-PAD-HERO.png?v=1786303972' },
    'robin egg': { label: 'Robin Egg Blue', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-REG-F3-PAD-HERO.jpg?v=1786303983' },
    'robin egg blue': { label: 'Robin Egg Blue', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-REG-F3-PAD-HERO.jpg?v=1786303983' },
    'bright blue': { label: 'Bright Blue', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-BBL-F3-PAD-HERO.png?v=1786303995' },
    'royal blue': { label: 'Royal Blue', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-RBL-F3-PAD-HERO.png?v=1786304008' },
    'purple': { label: 'Purple', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-PUR-F3-PAD-HERO.png?v=1786304017' },
    'burgundy': { label: 'Burgundy', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-BUR-F3-PAD-HERO.png?v=1786304026' },
    'red': { label: 'Red', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-RED-F3-PAD-HERO.png?v=1786304036' },
    'orange': { label: 'Orange', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-ORG-F3-PAD-HERO.png?v=1786304047' },
    'pink': { label: 'Pink', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-PNK-F3-PAD-HERO.png?v=1786304058' },
    'black': { label: 'Black', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-BLK-F3-PAD-HERO.png?v=1786304069' },
    'charcoal': { label: 'Charcoal', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-CHA-F3-PAD-HERO.png?v=1786304077' },
    'gray': { label: 'Gray', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-GRY-F3-PAD-HERO.png?v=1786304087' },
    'tan': { label: 'Tan', url: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-1IN-TAN-F3-PAD-HERO.png?v=1786304096' }
  };

  function normalize(value) {
    return String(value || '')
      .replace(/\s*\(1\s*inch\s*only\)\s*/ig, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function guideRoot() {
    return document.querySelector('[data-edg-guide]');
  }

  function currentColor() {
    var root = guideRoot();
    var select = root && root.querySelector('[data-color-select]');
    if (select && select.value) return select.value;
    if (root && root.dataset.colorValue) return root.dataset.colorValue;
    return 'Yellow';
  }

  function stage() {
    return document.querySelector('[data-edg-color-hero]');
  }

  function update(value) {
    var item = MAP[normalize(value)];
    var el = stage();
    if (!item || !el) return;
    var img = el.querySelector('[data-edg-color-hero-image]');
    var name = el.querySelector('[data-edg-color-hero-name]');
    if (!img || !name) return;
    name.textContent = item.label;
    if (img.dataset.source === item.url) return;
    img.classList.add('is-changing');
    var next = new Image();
    next.onload = function () {
      img.src = item.url;
      img.alt = 'FI Martingale Collar in ' + item.label + ' with Fi 3+ module installed';
      img.dataset.source = item.url;
      window.requestAnimationFrame(function () { img.classList.remove('is-changing'); });
    };
    next.onerror = function () { img.classList.remove('is-changing'); };
    next.src = item.url;
  }

  function mount() {
    var slot = document.querySelector('[data-edg-media-slot]');
    if (!slot) return false;
    var el = slot.querySelector('[data-edg-color-hero]');
    if (!el) {
      el = document.createElement('figure');
      el.className = 'edg-color-hero-stage';
      el.setAttribute('data-edg-color-hero', '');
      el.innerHTML = '<div class="edg-color-hero-stage__media"><img class="edg-color-hero-stage__image" data-edg-color-hero-image alt="" decoding="async" fetchpriority="high"></div><figcaption class="edg-color-hero-stage__caption" aria-live="polite"><span class="edg-color-hero-stage__label">Color preview · <strong data-edg-color-hero-name>Yellow</strong></span><span class="edg-color-hero-stage__note">Fi module shown installed for fit and placement. Tracker is included only when selected in your build.</span></figcaption>';
      slot.insertBefore(el, slot.firstChild);
    }
    slot.classList.add('edg-has-color-hero');
    update(currentColor());
    return true;
  }

  function init() {
    if (mount()) return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (mount() || attempts > 12) window.clearInterval(timer);
    }, 150);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-color-select]')) update(event.target.value);
  });
  document.addEventListener('eurus:variant:change', function () {
    window.setTimeout(function () { update(currentColor()); }, 0);
  });
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.setTimeout(init, 300);
  window.setTimeout(init, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-color-width-rule"]) return;
  try {
    
(function () {
  function selectedWidth(root) {
    var width = String(root.dataset.webbingWidth || '');
    if (width) return width;
    var legacy = String(root.dataset.fiSeries || '');
    if (/3\/4\s*inch/i.test(legacy)) return '3/4 inch';
    if (/\b1\s*inch\b/i.test(legacy)) return '1 inch';
    return '';
  }

  function isOneInch(root) {
    return /^1\s*inch$/i.test(selectedWidth(root));
  }

  function isOneInchOnly(option) {
    var original = option.dataset.edgOriginalLabel || option.textContent || option.value || '';
    return /\(\s*1\s*inch\s*only\s*\)/i.test(original);
  }

  function cleanLabel(text) {
    return String(text || '').replace(/\s*\(\s*1\s*inch\s*only\s*\)\s*/ig, '').trim();
  }

  function sync(root) {
    var select = root.querySelector('[data-color-select]');
    if (!select) return;

    var width = selectedWidth(root);
    var allowRestricted = isOneInch(root);
    var invalidSelected = false;

    Array.from(select.options).forEach(function (option) {
      if (!option.value) return;
      if (!option.dataset.edgOriginalLabel) option.dataset.edgOriginalLabel = option.textContent;
      if (!isOneInchOnly(option)) return;

      option.textContent = cleanLabel(option.dataset.edgOriginalLabel);
      option.hidden = !allowRestricted;
      option.disabled = !allowRestricted;
      if (!allowRestricted && option.selected) invalidSelected = true;
    });

    if (invalidSelected) {
      select.value = '';
      delete root.dataset.colorValue;
      var summary = root.querySelector('[data-step-summary="color"]');
      if (summary) summary.textContent = 'Choose a compatible color';
    }

    var body = select.closest('.edg-guide__body');
    var micro = body && body.querySelector('.edg-guide__micro');
    if (micro) {
      micro.textContent = width
        ? 'Only colors available for ' + width + ' webbing are shown.'
        : 'Choose webbing width first; color availability will update automatically.';
    }
  }

  function init(root) {
    if (!root || root.dataset.edgColorWidthRuleInitialized === 'true') return;
    root.dataset.edgColorWidthRuleInitialized = 'true';
    sync(root);

    var observer = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        return mutation.type === 'attributes' &&
          (mutation.attributeName === 'data-webbing-width' || mutation.attributeName === 'data-fi-series');
      });
      if (changed) sync(root);
    });
    observer.observe(root, { attributes: true, attributeFilter: ['data-webbing-width', 'data-fi-series'] });

    root.addEventListener('edg:build:width', function () { sync(root); });
  }

  function initAll(scope) {
    Array.from((scope || document).querySelectorAll('[data-edg-guide]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-compare-guidance"] && !Shopify.designMode) return;
  try {
    
(function(){'use strict';function q(root,sel){return root&&root.querySelector(sel)}function qa(root,sel){return root?Array.from(root.querySelectorAll(sel)):[]}function dog(){return window.EDGBuildSession&&window.EDGBuildSession.activeDog?window.EDGBuildSession.activeDog():{}}function seriesKind(d){var s=String(d.fiSeries||'').toLowerCase();if(s.indexOf('mini')>=0)return'mini';if(s.indexOf('ultra')>=0)return'ultra';if(s==='fi 2'||s.indexOf('series 2')>=0)return'2';if(s.indexOf('3+')>=0)return'3plus';if(s.indexOf('series 3')>=0)return'3';return''}function context(type,d){var k=seriesKind(d),fi=d.fiStatus==='yes';if(!fi){if(d.fiStatus==='learn'){if(type==='signature')return['Fi-integrated only','Supports Fi Series 2 and Series 3/3+. Fi Mini is not integrated.'];if(type==='adapter')return['Depends on tracker','Fi Mini uses Mini Compact; Fi 3+ can use Compact or Behavior on compatible gear.'];return['Standard or Fi path','Build standard now, or choose the integrated Fi version for supported Fi generations.']}if(type==='signature')return['Fi-only active listing','The non-Fi Signature Canvas listing is still in development and is not routed to customers.'];if(type==='adapter')return['Not needed','An adapter is only needed when adding a compatible Fi tracker to existing gear.'];return['Standard build','No Fi hardware is required for this setup.']}if(k==='mini'){if(type==='signature')return['Not compatible','Fi Mini is not integrated into Signature Canvas.'];if(type==='adapter')return['Recommended path','Fi Mini Compact Adapter attaches Mini to compatible collars or harnesses.'];return['Standard + adapter','Build the standard collar, then use the Fi Mini Compact Adapter on compatible gear.']}if(k==='ultra'){if(type==='adapter'||type==='signature')return['Not currently available','EDG does not currently list a verified Fi Ultra '+(type==='adapter'?'adapter':'Signature Canvas')+' path.'];return['Standard only','Build the standard collar without an unsupported Fi compatibility promise.']}if(k==='2'||k==='3'){if(type==='adapter')return['Integrated collar preferred','Current EDG adapter listings are not verified for '+(d.fiSeries||'this Fi generation')+'.'];return['Integrated Fi supported',type==='signature'?'Choose the matching Fi configuration in the 1-inch Signature Canvas build.':'Choose the integrated Fi version and continue with the product-specific fit guide.']}if(k==='3plus'){if(type==='adapter'){if(d.wear==='harness'&&d.harnessChoice==='harness-only')return['Compact Adapter','Harness-only setups use the Fi 3+ Compact Adapter; Behavior Adapter is collar-only.'];if(d.behavior==='yes')return['Behavior or Compact','Behavior Adapter preserves the intended collar position for behavior tracking; Compact remains available for GPS/geofence use.'];return['Compact or Behavior','Compact works on compatible collars or harnesses; Behavior Adapter is collar-only.']}return['Integrated Fi 3+ supported',type==='signature'?'One-inch Fi-integrated construction; choose size and canvas pattern.':'Continue to the integrated Fi collar; the builder carries the saved Fi 3+ setup forward.']}return['Compatibility checked in builder','Continue and the next step will only show supported choices.']}var definitions={'Traditional Buckle':{type:'traditional',copy:'Buckle closure. Neck measurement determines size. Choose 3/4-inch or 1-inch construction.'},'Martingale':{type:'martingale',copy:'Limited-slip design. Slip-over fit uses the larger of neck and widest head; Tactical Buckle fit uses neck.'},'Arctic Circle':{type:'arctic',copy:'Buckle-free slip-over design. Fit uses the larger of neck and widest head, then the larger published size when ranges overlap.'},'Inline Fi Collar':{type:'signature',title:'Signature Canvas',copy:'Hand-wrapped recycled canvas. Neck-based sizing, fixed 1-inch width, and an active Fi-integrated listing.'},'Signature Canvas':{type:'signature',title:'Signature Canvas',copy:'Hand-wrapped recycled canvas. Neck-based sizing, fixed 1-inch width, and an active Fi-integrated listing.'},'Fi Adapter':{type:'adapter',copy:'Adds compatible Fi hardware to gear the dog already owns. Final placement, strap width, and snap/hardware are chosen on the adapter.'}};function refresh(root){var d=dog(),compare=q(root,'[data-compare]');if(!compare)return;qa(compare,'.edg-compare__grid>div').forEach(function(card){var strong=q(card,'strong'),span=q(card,'span');if(!strong||!span)return;var def=definitions[strong.textContent.trim()];if(!def)return;if(def.title)strong.textContent=def.title;span.textContent=def.copy;card.dataset.edgFit=def.type;var pair=context(def.type,d),em=q(card,'em');if(!em){em=document.createElement('em');card.appendChild(em)}em.textContent=pair[0]+' · '+pair[1];card.dataset.edgStatus=/not compatible|not currently|not routed|not needed/i.test(pair[0]+' '+pair[1])?'limited':'ok'});var footer=q(compare,'p');if(footer)footer.textContent='Nothing compatible is silently removed. When a route is unavailable, EDG shows the reason and keeps the supported alternatives visible.'}function bind(root){if(!root||root.dataset.edgCompareBound)return;root.dataset.edgCompareBound='1';refresh(root);root.addEventListener('click',function(e){if(e.target.closest('button[data-value="compare"]'))setTimeout(function(){refresh(root)},0)})}function boot(){qa(document,'[data-edg-dog-profile]').forEach(bind)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);window.addEventListener('edg:session:change',function(){qa(document,'[data-edg-dog-profile]').forEach(refresh)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-dog-profile"] && !Shopify.designMode) return;
  try {
    
(function(){
 const KEY='edg-universal-walkthrough-v3';
 const blankDog=()=>({name:'',age:'',ageUnit:'years',breed:'',fiStatus:'',fiSeries:'',wear:'',harnessChoice:'',behavior:'',product:'',adapterFamily:'',adapterPlacement:'',adapterWidth:'',adapterSnap:''});
 let store={dogCount:'',dogs:[blankDog()],activeIndex:0};
 try{const saved=JSON.parse(sessionStorage.getItem(KEY)||'null');if(saved&&Array.isArray(saved.dogs)&&saved.dogs.length)store=saved}catch(e){}
 const clean=v=>(v||'').toString().trim();const cap=v=>{v=clean(v);return v?v.charAt(0).toUpperCase()+v.slice(1):''};
 const dog=()=>store.dogs[store.activeIndex]||store.dogs[0];const poss=()=>dog().name?(/s$/i.test(dog().name)?dog().name+'’':dog().name+'’s'):'your dog’s';
 function save(){try{sessionStorage.setItem(KEY,JSON.stringify(store))}catch(e){}}
 function stage(root,n,show=true){const e=root.querySelector('[data-stage="'+n+'"]');if(e)e.hidden=!show}
 function pick(group,val){group.querySelectorAll('button[data-value]').forEach(b=>b.classList.toggle('is-selected',b.dataset.value===val))}
 function focusStage(root,n){const e=root.querySelector('[data-stage="'+n+'"]');if(e)e.scrollIntoView({behavior:'smooth',block:'start'})}
 function populate(root){const d=dog();root.querySelector('[data-dog-name]').value=d.name||'';root.querySelector('[data-dog-age]').value=d.age||'';root.querySelector('[data-dog-age-unit]').value=d.ageUnit||'years';root.querySelector('[data-dog-breed]').value=d.breed||'';text(root)}
 function text(root){const d=dog(),n=d.name;const q=root.querySelector('[data-fi-question]');if(q)q.textContent='Does '+(n?n:'your dog')+' use Fi?';const fs=root.querySelector('[data-fi-series-heading]');if(fs)fs.textContent='Which Fi does '+(n?n:'your dog')+' use?';const w=root.querySelector('[data-wear-question]');if(w)w.textContent='What does '+(n?n:'your dog')+' usually wear?';const h=root.querySelector('[data-harness-heading]');if(h)h.textContent='Would you like to explore adding a collar, or keep '+poss()+' setup harness-only?';const ex=root.querySelector('[data-explore-heading]');if(ex)ex.textContent=n?'Explore '+n+'’s options.':'Explore your dog’s options.';const r=root.querySelector('[data-ready-heading]');if(r)r.textContent=n?n+'’s setup is ready.':'Your setup is ready.';const c=root.querySelector('[data-ready-copy]');if(c)c.textContent='Keep building with '+poss()+' details, outfit another dog, or review everything you’ve chosen.';const ba=root.querySelector('[data-build-another]');if(ba)ba.textContent=n?'Build Another for '+n:'Build Another for This Dog';const more=root.querySelector('[data-more-summary]');if(more)more.innerHTML='Tell us a little more'+(n?' about '+n:'')+' <small>Optional</small>';summary(root);updateCards(root)}
 function summary(root){const d=dog(),box=root.querySelector('[data-profile-summary]');if(!box)return;const parts=[];if(d.name)parts.push(d.name);if(d.fiStatus==='yes'&&d.fiSeries)parts.push(d.fiSeries);if(d.wear)parts.push(d.wear==='both'?'Collar + harness':d.wear.charAt(0).toUpperCase()+d.wear.slice(1));if(d.product){const names={traditional:'Traditional Buckle',martingale:'Martingale',arctic:'Arctic Circle',inline:'Inline Fi Collar',adapter:'Fi Adapter'};parts.push(names[d.product]||d.product)}box.innerHTML=parts.map(v=>'<span>'+v+'</span>').join('')}
 function statusFor(type){const d=dog();let unavailable=false,status='';
  const base={traditional:'Buckle closure • neck measurement, size, width + color',martingale:'Limited-slip construction • product-specific fit guidance',arctic:'Slip-over style • neck + head measurements required',inline:'Fi-integrated • neck size + Fi series + pattern',adapter:'Fi-specific accessory • device + strap width + snap/hardware choice'};
  status=base[type]||'';
  if(type==='inline'&&d.fiSeries==='Fi Mini'){unavailable=true;status='Not available for Fi Mini • other options remain visible'}
  if((type==='inline'||type==='adapter')&&d.fiSeries==='Fi Ultra'){unavailable=true;status='Fi Ultra accessories coming soon'}
  if(d.fiStatus==='not-currently'&&type!=='adapter'&&type!=='inline')status='Available without Fi • '+status;
  if(d.fiStatus==='learn'&&type!=='inline'&&type!=='adapter')status='We’ll explain Fi compatibility as you go • '+status;
  if(type==='adapter'&&d.fiSeries==='Fi Mini')status='Fi Mini Compact Adapter available • strap width + compatible hardware choices follow';
  if(type==='adapter'&&d.fiSeries==='Series 3+'){
    status=d.behavior==='yes'?'Fi 3+ Behavior Adapter or Compact Adapter • we’ll explain the difference':'Fi 3+ Compact or Behavior Adapter • choose based on how you use Fi';
  }
  if(type==='adapter'&&d.fiSeries==='Series 3')status='Fi Series 3 compatibility follows the current Fi 3 adapter family';
  if(d.fiSeries==='Series 3+'&&d.behavior==='yes'&&['traditional','martingale','arctic'].includes(type))status='Collar placement supports the behavior-tracking path • '+status;
  return{unavailable,status};
 }
 function updateCards(root){root.querySelectorAll('[data-product-card]').forEach(card=>{const s=statusFor(card.dataset.value);card.classList.toggle('is-unavailable',s.unavailable);card.setAttribute('aria-disabled',s.unavailable?'true':'false');const e=card.querySelector('[data-product-status]');if(e)e.textContent=s.status})}
 function showExplore(root){stage(root,'explore',true);updateCards(root)}
 function maybeBehavior(root){const d=dog();const relevant=d.fiSeries==='Series 3+'&&(d.wear==='harness'||d.wear==='both');stage(root,'behavior',relevant);if(!relevant)showExplore(root)}
 function resetSelections(root){root.querySelectorAll('.is-selected').forEach(e=>e.classList.remove('is-selected'));root.querySelector('[data-fi-series-wrap]').hidden=true;root.querySelector('[data-harness-followup]').hidden=true;root.querySelector('[data-behavior-note]').hidden=true;root.querySelector('[data-compat-note]').hidden=true;root.querySelector('[data-compare]').hidden=true;['fi','wear','behavior','explore','complete'].forEach(n=>stage(root,n,false))}
 function newDog(root){store.activeIndex=store.dogs.length;store.dogs.push(blankDog());save();resetSelections(root);stage(root,'profile',true);populate(root);focusStage(root,'profile')}
 function init(root){if(root.dataset.initialized)return;root.dataset.initialized='1';root.hidden=false;populate(root);
  root.addEventListener('click',function(ev){const b=ev.target.closest('button[data-value]');if(!b)return;const group=b.parentElement,val=b.dataset.value,d=dog();
   if(group.hasAttribute('data-dog-count')){store.dogCount=val;pick(group,val);stage(root,'profile',true);save();focusStage(root,'profile');return}
   if(group.hasAttribute('data-fi-status')){pick(group,val);d.fiStatus=val;if(val==='yes'){root.querySelector('[data-fi-series-wrap]').hidden=false}else{root.querySelector('[data-fi-series-wrap]').hidden=true;d.fiSeries='';stage(root,'wear',true);focusStage(root,'wear')}}
   else if(group.hasAttribute('data-fi-series')){pick(group,val);d.fiSeries=val;stage(root,'wear',true);focusStage(root,'wear')}
   else if(group.hasAttribute('data-wear')){pick(group,val);d.wear=val;if(val==='harness'){root.querySelector('[data-harness-followup]').hidden=false}else{root.querySelector('[data-harness-followup]').hidden=true;d.harnessChoice='';maybeBehavior(root);if(root.querySelector('[data-stage="behavior"]').hidden)focusStage(root,'explore')}}
   else if(group.hasAttribute('data-harness-choice')){pick(group,val);d.harnessChoice=val;maybeBehavior(root);focusStage(root,root.querySelector('[data-stage="behavior"]').hidden?'explore':'behavior')}
   else if(group.hasAttribute('data-behavior')){pick(group,val);d.behavior=val;root.querySelector('[data-behavior-note]').hidden=!(val==='yes'||val==='unsure');showExplore(root);focusStage(root,'explore')}
   else if(group.hasAttribute('data-product-choice')){const comp=root.querySelector('[data-compat-note]');if(val==='compare'){pick(group,val);root.querySelector('[data-compare]').hidden=false;comp.hidden=true;save();return}const s=statusFor(val);if(s.unavailable){comp.textContent=s.status+'. This option stays visible so you can see why it is unavailable for the setup you entered.';comp.hidden=false;root.querySelector('[data-compare]').hidden=true;return}pick(group,val);d.product=val;if(val==='adapter'){if(d.fiSeries==='Fi Mini')d.adapterFamily='mini-compact';else if(d.fiSeries==='Series 3+'&&d.behavior==='yes')d.adapterFamily='fi3-behavior-or-compact';else if(d.fiSeries==='Series 3'||d.fiSeries==='Series 3+')d.adapterFamily='fi3-compact-or-behavior';else d.adapterFamily='';}comp.hidden=true;root.querySelector('[data-compare]').hidden=true;stage(root,'complete',true);focusStage(root,'complete')}
   save();text(root)
  });
  root.addEventListener('input',function(ev){const d=dog();if(ev.target.matches('[data-dog-name]'))d.name=cap(ev.target.value);if(ev.target.matches('[data-dog-age]'))d.age=clean(ev.target.value);if(ev.target.matches('[data-dog-breed]'))d.breed=clean(ev.target.value);save();text(root)});
  root.addEventListener('change',function(ev){if(ev.target.matches('[data-dog-age-unit]'))dog().ageUnit=ev.target.value;save()});
  root.querySelector('[data-next="fi"]').addEventListener('click',function(){const d=dog();d.name=cap(root.querySelector('[data-dog-name]').value);d.age=clean(root.querySelector('[data-dog-age]').value);d.ageUnit=root.querySelector('[data-dog-age-unit]').value;d.breed=clean(root.querySelector('[data-dog-breed]').value);stage(root,'fi',true);text(root);save();focusStage(root,'fi')});
  root.querySelector('[data-build-another]').addEventListener('click',function(){dog().product='';stage(root,'complete',false);showExplore(root);save();focusStage(root,'explore')});
  root.querySelector('[data-outfit-another]').addEventListener('click',function(){newDog(root)});
  text(root)
 }
 function initAll(){document.querySelectorAll('[data-edg-dog-profile]').forEach(init)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();document.addEventListener('shopify:section:load',initAll)
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-feature-detail-cards"]) return;
  try {
    
(function(){
  var assets = {
    control: {
      src: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-CONTROL-LOOP-DETAIL.png?v=1786308386',
      alt: 'Fi Martingale limited-slip control loop detail',
      note: 'Construction detail shown for reference. Collar color is selected later.'
    },
    buckle: {
      src: document.querySelector('[data-edg-buckle-image]').dataset.edgBuckleImage,
      alt: 'EDG-branded quick-release buckle',
      note: 'EDG-branded quick-release buckle. Your selected collar color stays the same.'
    },
    nightguard: {
      src: 'https://cdn.shopify.com/s/files/1/0463/9345/8853/files/FMT-NIGHTGUARD-DETAIL.png?v=1786308355',
      alt: 'Fi Martingale NightGuard reflective edge detail',
      note: 'Reflective-edge detail shown in red for visibility. Your selected collar color stays the same.'
    }
  };

  function ensureDialog(){
    var dialog = document.querySelector('[data-edg-feature-zoom-dialog]');
    if(dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'edg-feature-zoom-dialog';
    dialog.setAttribute('data-edg-feature-zoom-dialog','');
    var shell = document.createElement('div');
    shell.className = 'edg-feature-zoom-dialog__shell';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'edg-feature-zoom-dialog__close';
    close.setAttribute('aria-label','Close detail image');
    close.textContent = '×';
    var img = document.createElement('img');
    img.className = 'edg-feature-zoom-dialog__image';
    img.setAttribute('data-edg-feature-zoom-image','');
    var caption = document.createElement('p');
    caption.className = 'edg-feature-zoom-dialog__caption';
    caption.setAttribute('data-edg-feature-zoom-caption','');
    shell.appendChild(close);
    shell.appendChild(img);
    shell.appendChild(caption);
    dialog.appendChild(shell);
    document.body.appendChild(dialog);
    close.addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()});
    return dialog;
  }

  function openZoom(asset){
    var dialog = ensureDialog();
    var img = dialog.querySelector('[data-edg-feature-zoom-image]');
    var caption = dialog.querySelector('[data-edg-feature-zoom-caption]');
    img.src = asset.src;
    img.alt = asset.alt;
    caption.textContent = asset.note;
    if(typeof dialog.showModal === 'function') dialog.showModal();
  }

  function makeCard(key,modifier){
    var asset = assets[key];
    var figure = document.createElement('figure');
    figure.className = 'edg-feature-detail' + (modifier ? ' edg-feature-detail--' + modifier : '');
    figure.setAttribute('data-edg-feature-detail',key);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'edg-feature-detail__button';
    button.setAttribute('aria-label','Enlarge ' + asset.alt);
    var img = document.createElement('img');
    img.className = 'edg-feature-detail__image';
    img.src = asset.src;
    img.alt = asset.alt;
    img.loading = 'lazy';
    img.decoding = 'async';
    var zoom = document.createElement('span');
    zoom.className = 'edg-feature-detail__zoom';
    zoom.textContent = 'View detail';
    var caption = document.createElement('figcaption');
    caption.textContent = asset.note;
    button.appendChild(img);
    button.appendChild(zoom);
    figure.appendChild(button);
    figure.appendChild(caption);
    button.addEventListener('click',function(){openZoom(asset)});
    return figure;
  }

  function after(node,newNode){
    if(!node || !node.parentNode) return;
    node.parentNode.insertBefore(newNode,node.nextSibling);
  }

  function mount(root){
    if(!root) return;

    var fit = root.querySelector('[data-step="fit"] .edg-guide__body');
    if(fit && !fit.querySelector('[data-edg-feature-detail="control"]')){
      var lead = fit.querySelector('.edg-guide__lead');
      if(lead) after(lead,makeCard('control','control'));
    }

    var closure = root.querySelector('[data-edg-closure-ui]');
    if(closure && !closure.querySelector('[data-edg-feature-detail="buckle"]')){
      var options = closure.querySelector('.edg-closure-choice__options');
      if(options) after(options,makeCard('buckle','closure'));
    }

    var night = root.querySelector('[data-edg-finish-panel="nightguard"]');
    if(night && !night.querySelector('[data-edg-feature-detail="nightguard"]')){
      var copy = night.querySelector('.edg-finish-copy');
      if(copy) after(copy,makeCard('nightguard','nightguard'));
    }
  }

  function init(root){
    if(!root || root.dataset.edgFeatureDetailsInitialized==='true') return;
    root.dataset.edgFeatureDetailsInitialized='true';
    mount(root);
    var queued = false;
    var observer = new MutationObserver(function(){
      if(queued) return;
      queued = true;
      window.requestAnimationFrame(function(){queued=false;mount(root)});
    });
    observer.observe(root,{childList:true,subtree:true});
  }

  function initAll(scope){
    Array.from((scope||document).querySelectorAll('[data-edg-guide]')).forEach(init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  }else{
    initAll(document);
  }
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);initAll(document)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-fi-width-rule"]) return;
  try {
    
(function () {
  function q(root, sel) { return root && root.querySelector(sel); }
  function qa(root, sel) { return root ? Array.from(root.querySelectorAll(sel)) : []; }

  function activeDog() {
    var session = window.EDGBuildSession;
    return session && session.activeDog ? session.activeDog() : null;
  }

  function savedGeneration(dog) {
    if (!dog || dog.fiStatus !== 'yes') return '';
    if (dog.fiSeries === 'Fi 2') return 'Fi Series 2';
    if (dog.fiSeries === 'Series 3' || dog.fiSeries === 'Series 3+') return 'Fi 3 / 3+';
    return '';
  }

  function savedLabel(dog) {
    return dog && dog.fiSeries ? dog.fiSeries : '';
  }

  function selectButton(group, button) {
    if (!group) return;
    qa(group, '[data-edg-fi-gen], [data-edg-webbing-width]').forEach(function (node) {
      var on = node === button;
      node.classList.toggle('is-selected', on);
      node.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function inferState(root) {
    var nativeValue = String(root.dataset.fiSeries || '');
    if (!root.dataset.fiGeneration) {
      if (/Series 2/i.test(nativeValue)) root.dataset.fiGeneration = 'Fi Series 2';
      else if (/3\/3\+/i.test(nativeValue)) root.dataset.fiGeneration = 'Fi 3 / 3+';
    }
    if (!root.dataset.webbingWidth) {
      if (/3\/4\s*inch/i.test(nativeValue)) root.dataset.webbingWidth = '3/4 inch';
      else if (/\b1\s*inch\b/i.test(nativeValue)) root.dataset.webbingWidth = '1 inch';
    }
  }

  function friendlySummary(root) {
    var generation = root.dataset.fiGeneration || '';
    var width = root.dataset.webbingWidth || '';
    if (!generation || !width) return '';
    var prefix = root.dataset.fiIntent === 'add' ? 'Add ' : '';
    return prefix + generation + ' · ' + width + ' webbing';
  }

  function syncSummary(root) {
    var text = friendlySummary(root);
    var summary = q(root, '[data-step-summary="fi"]');
    if (text && summary) summary.textContent = text;
  }

  function findNativeChoice(root, selector, value) {
    return qa(root, selector).find(function (button) {
      return String(button.dataset.nativeValue || '') === value;
    });
  }

  function applyWidth(root, width, widthButton) {
    var intent = root.dataset.fiIntent || '';
    var generation = root.dataset.fiGeneration || '';
    if (!generation && intent === 'add') {
      generation = 'Fi 3 / 3+';
      root.dataset.fiGeneration = generation;
    }
    if (!generation) return;

    root.dataset.webbingWidth = width;
    selectButton(q(root, '[data-edg-width-panel]'), widthButton);

    var nativeValue = /Series 2/i.test(generation)
      ? 'Fi Series 2'
      : 'Fi Series 3/3+ - ' + width;

    var selector = intent === 'add' ? '[data-fi-new-series]' : '[data-fi-series]';
    var nativeButton = findNativeChoice(root, selector, nativeValue);
    if (!nativeButton) {
      var status = q(root, '[data-status]');
      if (status) {
        status.textContent = 'That Fi generation and webbing width could not be matched to the current collar variant.';
        status.dataset.state = 'error';
      }
      return;
    }

    nativeButton.click();

    window.setTimeout(function () {
      root.dataset.fiGeneration = generation;
      root.dataset.webbingWidth = width;
      syncSummary(root);
      root.dispatchEvent(new CustomEvent('edg:build:width', {
        bubbles: true,
        detail: { generation: generation, webbingWidth: width }
      }));
    }, 0);
  }

  function render(root, helper) {
    inferState(root);
    var intent = root.dataset.fiIntent || '';
    var generationPanel = q(helper, '[data-edg-generation-panel]');
    var widthPanel = q(helper, '[data-edg-width-panel]');
    var saved = q(helper, '[data-edg-saved-fi-context]');
    var usingSaved = intent === 'own' && !!root.dataset.edgSavedFiGeneration;

    helper.hidden = intent === 'none' || !intent;
    if (helper.hidden) return;

    if (saved) saved.hidden = !usingSaved;

    if (intent === 'add') {
      root.dataset.fiGeneration = 'Fi 3 / 3+';
      generationPanel.hidden = true;
      widthPanel.hidden = false;
    } else if (usingSaved) {
      root.dataset.fiGeneration = root.dataset.edgSavedFiGeneration;
      generationPanel.hidden = true;
      widthPanel.hidden = false;
    } else {
      generationPanel.hidden = false;
      widthPanel.hidden = !root.dataset.fiGeneration;
    }

    qa(generationPanel, '[data-edg-fi-gen]').forEach(function (button) {
      var on = button.dataset.edgFiGen === root.dataset.fiGeneration;
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qa(widthPanel, '[data-edg-webbing-width]').forEach(function (button) {
      var on = button.dataset.edgWebbingWidth === root.dataset.webbingWidth;
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    syncSummary(root);
  }

  function seedSavedFi(root, helper, intentGroup) {
    if (root.dataset.edgSavedFiSeeded === 'true') return;
    var dog = activeDog();
    var generation = savedGeneration(dog);
    if (!generation) return;

    root.dataset.edgSavedFiSeeded = 'true';
    root.dataset.edgSavedFiGeneration = generation;
    root.dataset.edgSavedFiSeries = savedLabel(dog);

    var saved = q(helper, '[data-edg-saved-fi-context]');
    var savedText = q(helper, '[data-edg-saved-fi-text]');
    if (savedText) {
      var who = dog && dog.name ? dog.name + '’s' : 'Your';
      savedText.textContent = who + ' saved Fi setup is ' + savedLabel(dog) + '. Choose the webbing width for this collar.';
    }

    var own = q(intentGroup, '[data-fi-intent-choice="own"]');
    if (own) own.click();
    root.dataset.fiGeneration = generation;
    root.dataset.webbingWidth = '';
    render(root, helper);
  }

  function init(root) {
    if (!root || root.dataset.edgFiWidthInitialized === 'true') return;
    var step = q(root, '[data-step="fi"]');
    var body = step && q(step, '.edg-guide__body');
    var intentGroup = body && q(body, '[data-fi-intent]');
    if (!step || !body || !intentGroup) return;

    root.dataset.edgFiWidthInitialized = 'true';
    root.dataset.edgFiWidthV2 = 'true';

    var helper = document.createElement('div');
    helper.className = 'edg-fi-separate';
    helper.setAttribute('data-edg-fi-separate', '');
    helper.hidden = true;
    helper.innerHTML =
      '<div class="edg-fi-saved" data-edg-saved-fi-context hidden><strong data-edg-saved-fi-text></strong><button type="button" data-edg-change-fi>Change Fi setup</button></div>' +
      '<section class="edg-fi-separate__panel" data-edg-generation-panel hidden>' +
        '<p class="edg-guide__question">Which Fi generation does your dog use?</p>' +
        '<div class="edg-guide__choice-row">' +
          '<button type="button" class="edg-guide__choice" data-edg-fi-gen="Fi 3 / 3+" aria-pressed="false"><strong>Fi 3 / 3+</strong><small>Series 3 or Series 3+</small></button>' +
          '<button type="button" class="edg-guide__choice" data-edg-fi-gen="Fi Series 2" aria-pressed="false"><strong>Fi Series 2</strong><small>Previous Fi tracker interface</small></button>' +
        '</div>' +
        '<p class="edg-fi-separate__note"><strong>Fi generation selects the tracker hardware interface.</strong> It does not determine the width of your collar.</p>' +
      '</section>' +
      '<section class="edg-fi-separate__panel" data-edg-width-panel hidden>' +
        '<p class="edg-guide__question">Choose your webbing width.</p>' +
        '<div class="edg-guide__choice-row">' +
          '<button type="button" class="edg-guide__choice" data-edg-webbing-width="1 inch" aria-pressed="false"><strong>1 inch webbing</strong><small>Physical collar construction choice</small></button>' +
          '<button type="button" class="edg-guide__choice" data-edg-webbing-width="3/4 inch" aria-pressed="false"><strong>3/4 inch webbing</strong><small>Physical collar construction choice</small></button>' +
        '</div>' +
        '<p class="edg-fi-separate__note">Webbing width is selected independently from Fi generation. Color availability is filtered from this width choice.</p>' +
      '</section>';

    var route = q(body, '[data-non-fi-route]');
    if (route) body.insertBefore(helper, route);
    else body.appendChild(helper);

    qa(intentGroup, '[data-fi-intent-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        var intent = button.dataset.fiIntentChoice || '';
        if (intent !== 'own') {
          delete root.dataset.edgSavedFiGeneration;
          delete root.dataset.edgSavedFiSeries;
          intentGroup.hidden = false;
        }
        if (intent === 'own' || intent === 'add') {
          root.dataset.fiGeneration = intent === 'add' ? 'Fi 3 / 3+' : '';
          root.dataset.webbingWidth = '';
        }
        window.setTimeout(function () { render(root, helper); }, 0);
      });
    });

    qa(helper, '[data-edg-fi-gen]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.dataset.fiGeneration = button.dataset.edgFiGen;
        root.dataset.webbingWidth = '';
        selectButton(q(helper, '[data-edg-generation-panel]'), button);
        q(helper, '[data-edg-width-panel]').hidden = false;
        qa(q(helper, '[data-edg-width-panel]'), '[data-edg-webbing-width]').forEach(function (node) {
          node.classList.remove('is-selected');
          node.setAttribute('aria-pressed', 'false');
        });
      });
    });

    qa(helper, '[data-edg-webbing-width]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyWidth(root, button.dataset.edgWebbingWidth, button);
      });
    });

    var change = q(helper, '[data-edg-change-fi]');
    if (change) change.addEventListener('click', function () {
      delete root.dataset.edgSavedFiGeneration;
      delete root.dataset.edgSavedFiSeries;
      root.dataset.fiGeneration = '';
      root.dataset.webbingWidth = '';
      intentGroup.hidden = false;
      var saved = q(helper, '[data-edg-saved-fi-context]');
      if (saved) saved.hidden = true;
      render(root, helper);
      intentGroup.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var observer = new MutationObserver(function () {
      if (step.classList.contains('is-active')) render(root, helper);
    });
    observer.observe(step, { attributes: true, attributeFilter: ['class'] });

    inferState(root);
    seedSavedFi(root, helper, intentGroup);
    render(root, helper);
  }

  function initAll(scope) {
    qa(scope || document, '[data-edg-guide]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    window.setTimeout(function () { initAll(document); }, 100);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-finish-clarity"]) return;
  try {
    
(function(){
  function q(root,sel){return root&&root.querySelector(sel)}
  function qa(root,sel){return root?Array.from(root.querySelectorAll(sel)):[]}
  function enhance(root){
    if(!root||root.dataset.edgFinishClarityInitialized==='true')return false;
    var guide=q(root,'[data-edg-finish-guide]');
    if(!guide)return false;
    var adapter=q(guide,'[data-edg-finish-panel="adapter"]');
    var adapterType=q(guide,'[data-edg-finish-panel="adapter-type"]');
    var intent=q(guide,'[data-edg-adapter-intent]');
    var types=q(guide,'[data-edg-adapter-types]');
    if(!adapter||!adapterType||!intent||!types)return false;
    var compact=q(types,'[data-edg-finish-value="compact"]');
    if(!compact)return false;
    root.dataset.edgFinishClarityInitialized='true';
    root.dataset.edgCompactOnly='true';

    var ah=q(adapter,'h3'), ac=q(adapter,'.edg-finish-copy');
    if(ah)ah.textContent='Want to use your Fi 3+ on other gear too?';
    if(ac)ac.textContent='Your Fi Martingale is already built to hold your tracker. The Compact Adapter is an additional, separate piece that lets you move the same Fi 3+ tracker to another compatible collar or harness.';

    var no=q(intent,'[data-edg-finish-value="no"]');
    var yes=q(intent,'[data-edg-finish-value="yes"]');
    if(no){
      var ns=q(no,'strong'), nsm=q(no,'small'), nb=q(no,'b');
      if(ns)ns.textContent='No — I’ll keep my Fi on this collar';
      if(nsm)nsm.textContent='Nothing else is needed for this Martingale.';
      if(nb)nb.textContent='No extra piece';
    }
    if(yes){
      var ys=q(yes,'strong'), ysm=q(yes,'small'), yb=q(yes,'b');
      var cb=q(compact,'b');
      if(ys)ys.textContent='Yes — add an extra Compact Adapter';
      if(ysm)ysm.textContent='A separate piece for moving the same tracker to other compatible gear.';
      if(yb)yb.textContent=cb&&cb.textContent.trim()?cb.textContent.trim():'Optional';
      yes.addEventListener('click',function(){
        window.setTimeout(function(){
          if(!adapterType.hidden&&compact)compact.click();
        },0);
      });
    }

    if(!q(adapter,'[data-edg-compact-separate-note]')){
      var note=document.createElement('p');
      note.className='edg-finish-note edg-compact-separate-note';
      note.setAttribute('data-edg-compact-separate-note','');
      note.innerHTML='<strong>This is an additional piece.</strong> When you move the Fi tracker to other gear, your Martingale stays behind with its Fi links/mounting points but without the tracker attached. A second Fi tracker is not included.';
      adapter.appendChild(note);
    }

    var kicker=q(adapterType,'.edg-finish-kicker'), th=q(adapterType,'h3'), tc=q(adapterType,'.edg-finish-copy'), tn=q(adapterType,'.edg-finish-note');
    if(kicker)kicker.textContent='EXTRA FI 3+ COMPACT ADAPTER';
    if(th)th.textContent='Choose the fit for your extra Compact Adapter.';
    if(tc)tc.textContent='This adapter is separate from the Fi hardware built into your Martingale. Choose the configuration that matches the other collar, harness or gear where you plan to use your tracker.';
    if(tn)tn.textContent='We only offer the Compact Adapter inside this collar builder because your Martingale already provides the collar-based Fi setup.';
    qa(types,'[data-edg-finish-choice]').forEach(function(b){if(b!==compact)b.remove()});
    return true;
  }
  function init(scope){
    qa(scope||document,'[data-edg-guide]').forEach(function(root){
      if(enhance(root))return;
      var tries=0, timer=window.setInterval(function(){tries++;if(enhance(root)||tries>12)window.clearInterval(timer)},150);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);init(document)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-finish-guidance"]) return;
  try {
    
(function(){
function q(root,sel){return root.querySelector(sel)}
function qa(root,sel){return Array.from(root.querySelectorAll(sel))}
function fireChange(el){if(el)el.dispatchEvent(new Event('change',{bubbles:true}))}
function adapterEligible(root){var s=root.dataset.fiSeries||'';return /3\/3\+/i.test(s)&&!/Series 2/i.test(s)}
function currentAdapterTypeLabel(root){var s=q(root,'[data-adapter-type]');if(!s||!s.value||s.selectedIndex<0)return '';return(s.options[s.selectedIndex].textContent||'').split(' — ')[0].trim()}
function currentAdapterVariantLabel(root){var s=q(root,'[data-adapter-variant]');if(!s||!s.value||s.selectedIndex<0)return '';var o=s.options[s.selectedIndex];return(o.dataset.title||o.textContent||'').split(' — ')[0].trim()}
function setSelected(group,value){if(!group)return;qa(group,'[data-edg-finish-value]').forEach(function(b){var on=b.dataset.edgFinishValue===value;b.classList.toggle('is-selected',on);b.setAttribute('aria-pressed',on?'true':'false')})}
function priceFromNightguard(root){var i=q(root,'[data-nightguard]'),l=i&&i.closest('label'),p=l&&l.querySelector('b');return p?p.textContent.trim():''}
function adapterOption(root,match){var s=q(root,'[data-adapter-type]');if(!s)return null;return Array.from(s.options).find(function(o){return o.value&&match.test(o.textContent||'')})||null}
function clearAdapter(root){var t=q(root,'[data-add-adapter]'),type=q(root,'[data-adapter-type]'),v=q(root,'[data-adapter-variant]'),w=q(root,'[data-adapter-variant-wrap]');if(t&&t.checked){t.checked=false;fireChange(t)}if(type)type.value='';if(v)v.value='';if(w)w.hidden=true}
function summaryText(root){var p=[],n=q(root,'[data-nightguard]'),a=q(root,'[data-add-adapter]');if(n&&n.checked)p.push('NightGuard');if(adapterEligible(root)&&a&&a.checked)p.push('Fi 3+ adapter');return p.length?p.join(' · '):'Standard finish'}
function syncFinishSummary(root){var n=q(root,'[data-step-summary="finish"]');if(n)n.textContent=summaryText(root)}
function build(root){var finish=q(root,'[data-step="finish"]');if(!finish||finish.dataset.edgFinishGuidanceInitialized==='true')return;var body=q(finish,'.edg-guide__body'),night=q(root,'[data-nightguard]'),toggle=q(root,'[data-add-adapter]'),area=q(root,'[data-adapter-area]'),type=q(root,'[data-adapter-type]'),variantWrap=q(root,'[data-adapter-variant-wrap]'),variant=q(root,'[data-adapter-variant]'),nativeReview=q(root,'[data-finish-review]');if(!body||!night||!nativeReview)return;finish.dataset.edgFinishGuidanceInitialized='true';var nl=night.closest('label'),al=toggle&&toggle.closest('label'),tl=type&&type.closest('label');if(nl)nl.classList.add('edg-finish-native');if(al)al.classList.add('edg-finish-native');if(tl)tl.classList.add('edg-finish-native');nativeReview.classList.add('edg-finish-native');if(variantWrap){variantWrap.classList.add('edg-finish-native-variant');variantWrap.hidden=true}var compact=adapterOption(root,/Compact Adapter/i),behavior=adapterOption(root,/Behavior Adapter/i),nightPrice=priceFromNightguard(root)||'+$10.00';var guide=document.createElement('div');guide.className='edg-finish-guide';guide.setAttribute('data-edg-finish-guide','');guide.innerHTML='<section class="edg-finish-panel" data-edg-finish-panel="nightguard"><p class="edg-finish-kicker" data-edg-finish-count>FINISH · 1 OF 2</p><h3>Would you like reflective visibility built into the collar?</h3><p class="edg-finish-copy">NightGuard adds reflective trim along both outer edges. It is sewn in while we build the collar and catches light from headlights, flashlights and streetlamps. It does not change the collar\'s fit.</p><div class="edg-finish-choices" data-edg-nightguard-choices><button type="button" class="edg-finish-choice" data-edg-finish-value="yes" aria-pressed="false"><strong>Add NightGuard Reflective Edge</strong><small>Reflective side trim built into your collar.</small><b>'+nightPrice+'</b></button><button type="button" class="edg-finish-choice" data-edg-finish-value="no" aria-pressed="false"><strong>Keep the standard edge</strong><small>No reflective trim. Same collar fit and construction.</small><b>Included</b></button></div><p class="edg-finish-note">NightGuard is most useful when you want the collar to catch direct light in low-light conditions. It is visibility trim, not a light source.</p></section><section class="edg-finish-panel" data-edg-finish-panel="adapter" hidden><button type="button" class="edg-finish-back" data-edg-finish-back="nightguard">← Back to reflective edge</button><p class="edg-finish-kicker">FINISH · 2 OF 2</p><h3>Will you want to use this Fi 3+ on other gear?</h3><p class="edg-finish-copy">Your Fi Martingale already holds the tracker. An adapter is optional extra gear for moving the same Fi 3+ module to another compatible collar or harness.</p><div class="edg-finish-choices" data-edg-adapter-intent><button type="button" class="edg-finish-choice" data-edg-finish-value="no" aria-pressed="false"><strong>No adapter</strong><small>This collar is all I need right now.</small><b>None</b></button><button type="button" class="edg-finish-choice" data-edg-finish-value="yes" aria-pressed="false"><strong>Add a Fi 3+ adapter</strong><small>Help me choose the right adapter.</small><b>Optional</b></button></div></section><section class="edg-finish-panel" data-edg-finish-panel="adapter-type" hidden><button type="button" class="edg-finish-back" data-edg-finish-back="adapter">← Back</button><p class="edg-finish-kicker">CHOOSE YOUR ADAPTER</p><h3>What do you need the adapter to do?</h3><p class="edg-finish-copy">We’ll match the adapter to how you use Fi rather than asking you to decode product names.</p><div class="edg-finish-choices" data-edg-adapter-types>'+(compact?'<button type="button" class="edg-finish-choice" data-edg-finish-value="compact" data-adapter-handle="'+compact.value+'" aria-pressed="false"><strong>GPS + geofence</strong><small>Compact Adapter · works on compatible collars or harnesses.</small><b>'+((compact.textContent||'').split(' — ').slice(1).join(' — ')||'$55')+'</b></button>':'')+(behavior?'<button type="button" class="edg-finish-choice" data-edg-finish-value="behavior" data-adapter-handle="'+behavior.value+'" aria-pressed="false"><strong>Behavior + GPS + geofence</strong><small>Behavior Adapter · designed for collar use.</small><b>'+((behavior.textContent||'').split(' — ').slice(1).join(' — ')||'$75')+'</b></button>':'')+'</div><p class="edg-finish-note">After you choose the job, we’ll show the adapter’s actual fit and hardware choices from Shopify.</p><div data-edg-adapter-native-slot></div></section><section class="edg-finish-panel edg-finish-ready" data-edg-finish-panel="ready" hidden><p class="edg-finish-kicker">READY TO REVIEW</p><h3>Your collar choices are set.</h3><p class="edg-finish-copy">We’ll show the complete build before anything is added to your cart.</p><div class="edg-finish-ready-list"><div class="edg-finish-ready-row"><span>Reflective edge</span><strong data-edg-ready-nightguard></strong></div><div class="edg-finish-ready-row" data-edg-ready-adapter-row><span>Additional Fi gear</span><strong data-edg-ready-adapter></strong></div></div><button type="button" class="edg-finish-review-button" data-edg-review>Review my setup</button><button type="button" class="edg-finish-back" data-edg-finish-back="nightguard">Change finish choices</button></section>';body.prepend(guide);var slot=q(guide,'[data-edg-adapter-native-slot]');if(variantWrap&&slot)slot.appendChild(variantWrap);function panel(name){return q(guide,'[data-edg-finish-panel="'+name+'"]')}function show(name){qa(guide,'[data-edg-finish-panel]').forEach(function(n){n.hidden=n.dataset.edgFinishPanel!==name});if(name!=='adapter-type'&&variantWrap)variantWrap.hidden=true}function refreshCount(){var c=q(guide,'[data-edg-finish-count]');if(c)c.textContent=adapterEligible(root)?'FINISH · 1 OF 2':'FINISH · 1 OF 1'}function ready(){refreshCount();var rn=q(guide,'[data-edg-ready-nightguard]'),ra=q(guide,'[data-edg-ready-adapter]'),row=q(guide,'[data-edg-ready-adapter-row]');if(rn)rn.textContent=night.checked?'NightGuard Reflective Edge '+nightPrice:'Standard edge';if(row)row.hidden=!adapterEligible(root);if(ra&&adapterEligible(root)){if(toggle&&toggle.checked){var tt=currentAdapterTypeLabel(root)||'Fi 3+ adapter',vt=currentAdapterVariantLabel(root);ra.textContent=vt?tt+' · '+vt:tt}else ra.textContent='No adapter'}syncFinishSummary(root);show('ready')}function reset(){refreshCount();setSelected(q(guide,'[data-edg-nightguard-choices]'),night.checked?'yes':'no');if(!adapterEligible(root))clearAdapter(root);show('nightguard')}qa(q(guide,'[data-edg-nightguard-choices]'),'[data-edg-finish-value]').forEach(function(b){b.addEventListener('click',function(){var yes=b.dataset.edgFinishValue==='yes';night.checked=yes;fireChange(night);setSelected(q(guide,'[data-edg-nightguard-choices]'),yes?'yes':'no');syncFinishSummary(root);if(adapterEligible(root)){setSelected(q(guide,'[data-edg-adapter-intent]'),toggle&&toggle.checked?'yes':'no');show('adapter')}else{clearAdapter(root);ready()}})});qa(q(guide,'[data-edg-adapter-intent]'),'[data-edg-finish-value]').forEach(function(b){b.addEventListener('click',function(){var yes=b.dataset.edgFinishValue==='yes';setSelected(q(guide,'[data-edg-adapter-intent]'),yes?'yes':'no');if(!yes){clearAdapter(root);ready();return}if(toggle&&!toggle.checked){toggle.checked=true;fireChange(toggle)}show('adapter-type')})});qa(q(guide,'[data-edg-adapter-types]'),'[data-edg-finish-value]').forEach(function(b){b.addEventListener('click',function(){var h=b.dataset.adapterHandle;if(!type||!h)return;type.value=h;setSelected(q(guide,'[data-edg-adapter-types]'),b.dataset.edgFinishValue);fireChange(type);if(variantWrap){variantWrap.hidden=false;variantWrap.scrollIntoView({behavior:'smooth',block:'nearest'})}})});if(variant)variant.addEventListener('change',function(){if(variant.value)ready()});qa(guide,'[data-edg-finish-back]').forEach(function(b){b.addEventListener('click',function(){var target=b.dataset.edgFinishBack;if(target==='nightguard')reset();else if(target==='adapter'){if(variantWrap)variantWrap.hidden=true;show('adapter')}})});var review=q(guide,'[data-edg-review]');if(review)review.addEventListener('click',function(){if(adapterEligible(root)&&toggle&&toggle.checked&&(!type||!type.value||!variant||!variant.value)){show('adapter-type');if(variantWrap)variantWrap.hidden=false;return}syncFinishSummary(root);nativeReview.click()});night.addEventListener('change',function(){syncFinishSummary(root)});var observer=new MutationObserver(function(){if(finish.classList.contains('is-active')&&finish.dataset.edgFinishWasActive!=='true'){finish.dataset.edgFinishWasActive='true';reset()}else if(!finish.classList.contains('is-active'))finish.dataset.edgFinishWasActive='false';refreshCount()});observer.observe(finish,{attributes:true,attributeFilter:['class']});observer.observe(root,{attributes:true,attributeFilter:['data-fi-series']});reset()}
function init(scope){qa(scope||document,'[data-edg-guide]').forEach(build)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);document.addEventListener('shopify:section:load',function(e){init(e.target);init(document)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-guided-martingale"] && !Shopify.designMode) return;
  try {
    
(function () {
  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));

  function isFiReferral() {
    const p = new URLSearchParams(location.search);
    const source = (p.get('utm_source') || p.get('source') || '').toLowerCase();
    const ref = (document.referrer || '').toLowerCase();
    return source === 'fi' || source.includes('tryfi') || ref.includes('tryfi.com');
  }

  function pretty(n) { return Number(Number(n).toFixed(3)).toString(); }

  function opening(root) {
    const neck = Number($(root, '[data-neck]').value);
    const head = Number($(root, '[data-head]').value);
    return neck > 0 && head > 0 ? Math.max(neck, head) : null;
  }

  function nativeContainer(optionHandle) {
    return document.querySelector('.theme-template-suffix-edg-fi-martingale .variant-selects-main [data-option-name="' + optionHandle + '"]');
  }

  function nativeSelected(optionHandle) {
    const container = nativeContainer(optionHandle);
    if (!container) return '';
    const radio = container.querySelector('input:checked');
    if (radio) return radio.value;
    const select = container.querySelector('select');
    if (select) return select.value;
    return '';
  }

  function applyNative(optionHandle, value) {
    const container = nativeContainer(optionHandle);
    if (!container) return false;
    const radios = Array.from(container.querySelectorAll('input[type="radio"]'));
    const radio = radios.find(el => el.value === value);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const select = container.querySelector('select');
    if (select) {
      const index = Array.from(select.options).findIndex(o => o.value === value || o.textContent.trim() === value);
      if (index >= 0) {
        select.selectedIndex = index;
        Array.from(select.options).forEach(o => o.removeAttribute('selected'));
        select.options[index].setAttribute('selected', 'selected');
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function nativeVariantId(root) {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(form => !root.contains(form));
    const preferred = forms.find(form => (form.getAttribute('id') || '').indexOf('product-form-') === 0 && form.querySelector('input[name="id"]')) || forms.find(form => form.querySelector('input[name="id"]'));
    const input = preferred && preferred.querySelector('input[name="id"]');
    return input && input.value ? Number(input.value) : null;
  }

  function setStatus(root, message, state) {
    const node = $(root, '[data-status]');
    node.textContent = message || '';
    if (state) node.dataset.state = state; else delete node.dataset.state;
  }

  function setStep(root, key, state) {
    const step = $(root, '[data-step="' + key + '"]');
    if (!step) return;
    step.classList.remove('is-active', 'is-complete', 'is-locked');
    step.classList.add('is-' + state);
    const header = $(step, '[data-edit-step]');
    if (header) {
      header.disabled = state === 'locked';
      header.setAttribute('aria-expanded', state === 'active' ? 'true' : 'false');
    }
    const progress = $(root, '[data-progress="' + key + '"]');
    if (progress) {
      progress.classList.toggle('is-active', state === 'active');
      progress.classList.toggle('is-complete', state === 'complete');
    }
  }

  function focusActiveStep(root) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      const step = $(root, '[data-step].is-active');
      if (!step) return;
      const header = $(step, '[data-edit-step]') || step;
      const sticky = document.querySelector('.section-header.is-sticky');
      const offset = 16 + (sticky ? Math.max(0, sticky.getBoundingClientRect().height) : 0);
      const top = Math.max(0, window.scrollY + header.getBoundingClientRect().top - offset);
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top, behavior });
      if (header.focus) header.focus({ preventScroll: true });
    }));
  }

  function activateStep(root, key) {
    const order = ['fit', 'fi', 'finish', 'color'];
    const index = order.indexOf(key);
    order.forEach((name, i) => {
      if (i < index) setStep(root, name, 'complete');
      else if (i === index) setStep(root, name, 'active');
      else setStep(root, name, 'locked');
    });
    $(root, '[data-review]').hidden = true;
  }

  function updateFit(root) {
    const required = opening(root);
    const result = $(root, '[data-fit-result]');
    const sizes = $(root, '[data-size-results]');
    if (!required) {
      result.hidden = true;
      sizes.hidden = true;
      return;
    }
    result.hidden = false;
    $(root, '[data-opening]').textContent = pretty(required) + ' in';
    sizes.hidden = false;

    const buttons = $$(root, '[data-size-choice]');
    let matches = 0;
    buttons.forEach(button => {
      const label = button.dataset.nativeValue || '';
      const match = label.match(/([0-9]+(?:\.[0-9]+)?)\s*-\s*([0-9]+(?:\.[0-9]+)?)/);
      const custom = /custom/i.test(label);
      let show = false;
      if (match) {
        const min = Number(match[1]);
        const max = Number(match[2]);
        show = required >= min && required <= max;
        if (show) matches += 1;
      }
      button.hidden = !show;
      button.dataset.custom = custom ? 'true' : 'false';
    });

    if (matches === 0) {
      const custom = buttons.find(button => /custom/i.test(button.dataset.nativeValue || ''));
      if (custom) custom.hidden = false;
      $(root, '[data-size-note]').textContent = 'Your measurement falls outside the published standard ranges. Custom sizing is the correct next path.';
    } else if (matches > 1) {
      $(root, '[data-size-note]').textContent = 'Two published ranges include this exact measurement. Both meet the stated opening range; choose one here while we formalize EDG’s overlap recommendation rule.';
    } else {
      $(root, '[data-size-note]').textContent = 'Only the published size range that contains your dog’s required opening is shown.';
    }
  }

  function selectChoice(button, group) {
    $$(group, '.edg-guide__choice').forEach(el => el.classList.remove('is-selected'));
    button.classList.add('is-selected');
  }

  function showFiIntent(root, intent, button) {
    selectChoice(button, $(root, '[data-fi-intent]'));
    $(root, '[data-fi-existing]').hidden = intent !== 'own';
    $(root, '[data-fi-new]').hidden = intent !== 'add';
    $(root, '[data-non-fi-route]').hidden = intent !== 'none';
    root.dataset.fiIntent = intent;
    root.dataset.fiMode = '';
    root.dataset.fiSeries = '';
    if (intent === 'none') {
      $(root, '[data-step-summary="fi"]').textContent = 'Standard martingale recommended';
    }
  }

  function completeFi(root, button, mode) {
    const option = button.dataset.nativeOption;
    const value = button.dataset.nativeValue;
    if (!applyNative(option, value)) {
      setStatus(root, 'We could not apply that Fi option to the current Eurus product selector.', 'error');
      return;
    }
    root.dataset.fiMode = mode;
    root.dataset.fiSeries = value;
    $(root, '[data-step-summary="fi"]').textContent = mode === 'add-3' ? 'New Fi 3+ · ' + value.replace('Fi Series 3/3+ - ', '') : value;
    setStep(root, 'fi', 'complete');
    setStep(root, 'finish', 'active');
    setStep(root, 'color', 'locked');
    const adapterArea = $(root, '[data-adapter-area]');
    if (adapterArea) adapterArea.hidden = /Series 2/i.test(root.dataset.fiSeries || '');
  }

  function syncColorAvailability(root) {
    const select = $(root, '[data-color-select]');
    if (!select) return;
    Array.from(select.options).forEach(option => {
      if (!option.value) return;
      const native = nativeContainer(option.dataset.nativeOption || 'color');
      if (!native) return;
      const input = Array.from(native.querySelectorAll('input[type="radio"]')).find(el => el.value === option.value);
      if (input) option.disabled = input.dataset.available === 'false' || input.classList.contains('disabled');
    });
  }

  function reuseChosenColor(root, session) {
    const dog=session&&session.activeDog?session.activeDog():null;
    const chosen=root.dataset.preferredColor||(dog&&dog.preferredColor)||'';
    if(!chosen)return false;
    root.dataset.preferredColor=chosen;
    const select=$(root,'[data-color-select]');
    if(!select)return false;
    const normalize=value=>String(value||'').toLowerCase().replace(/\([^)]*\)/g,'').replace(/1[- ]inch styles/g,'').replace(/[^a-z]/g,'');
    const option=Array.from(select.options).find(item=>item.value&&normalize(item.value)===normalize(chosen));
    const stringsNode=document.querySelector('[data-edg-color-strings]');
    const strings=stringsNode?JSON.parse(stringsNode.textContent):{};
    if(!option||option.disabled||option.hidden){
      if(strings.unavailable)setStatus(root,strings.unavailable,'error');
      return false;
    }
    select.value=option.value;
    select.dispatchEvent(new Event('change',{bubbles:true}));
    if(typeof syncSwatches==='function')syncSwatches(root);
    if(root.dataset.colorValue===option.value){if(strings.saved)setStatus(root,strings.saved,'success');return true;}
    return false;
  }

  async function productJson(handle) {
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to load adapter options.');
    return response.json();
  }

  async function loadAdapter(root) {
    const type = $(root, '[data-adapter-type]');
    const wrap = $(root, '[data-adapter-variant-wrap]');
    const select = $(root, '[data-adapter-variant]');
    select.innerHTML = '';
    if (!type.value) { wrap.hidden = true; updateReview(root); return; }
    wrap.hidden = false;
    select.innerHTML = '<option>Loading…</option>';
    try {
      const data = await productJson(type.value);
      select.innerHTML = '<option value="">Choose fit & hardware</option>';
      data.variants.forEach(variant => {
        const o = document.createElement('option');
        o.value = variant.id;
        o.textContent = variant.title + ' — ' + new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(variant.price / 100);
        o.dataset.title = variant.title;
        o.disabled = variant.available === false;
        select.appendChild(o);
      });
      updateReview(root);
    } catch (e) {
      wrap.hidden = true;
      setStatus(root, e.message || 'Unable to load adapter options.', 'error');
    }
  }

  function updateReview(root) {
    const required = opening(root);
    const nightguard = $(root, '[data-nightguard]');
    const adapterOn = $(root, '[data-add-adapter]');
    const adapterType = $(root, '[data-adapter-type]');
    const adapterVariant = $(root, '[data-adapter-variant]');
    $(root, '[data-review-fit]').textContent = required ? pretty(required) + ' in required opening' : '';
    $(root, '[data-review-size]').textContent = root.dataset.sizeValue || '';
    $(root, '[data-review-fi]').textContent = root.dataset.fiMode === 'add-3' ? 'New Fi 3+ + ' + (root.dataset.fiSeries || '') : (root.dataset.fiSeries || '');
    $(root, '[data-review-color]').textContent = root.dataset.colorValue || '';
    $(root, '[data-review-built]').textContent = nightguard && nightguard.checked ? 'NightGuard Reflective Edge' : 'Standard build';
    const gear = [];
    if (root.dataset.fiMode === 'add-3') gear.push(root.dataset.fi3Title || 'Fi 3+');
    if (adapterOn && adapterOn.checked && adapterType && adapterType.value) {
      const typeLabel = adapterType.options[adapterType.selectedIndex].textContent.split(' — ')[0];
      const variantLabel = adapterVariant && adapterVariant.value && adapterVariant.options[adapterVariant.selectedIndex] ? adapterVariant.options[adapterVariant.selectedIndex].dataset.title : '';
      gear.push(variantLabel ? typeLabel + ' / ' + variantLabel : typeLabel);
    }
    $(root, '[data-review-gear]').textContent = gear.length ? gear.join(' + ') : 'None';
  }

  function selectionsMatch(root) {
    return nativeSelected('size') === (root.dataset.sizeValue || '') &&
      nativeSelected('fi-series-see-images') === (root.dataset.fiSeries || '') &&
      nativeSelected('color') === (root.dataset.colorValue || '');
  }

  function waitForNative(root, timeout) {
    return new Promise(resolve => {
      const start = Date.now();
      const check = () => {
        if (selectionsMatch(root) && nativeVariantId(root)) return resolve(true);
        if (Date.now() - start >= timeout) return resolve(false);
        setTimeout(check, 100);
      };
      check();
    });
  }

  async function addSetup(root) {
    setStatus(root, 'Checking your selected configuration…');
    const required = opening(root);
    if (!required || !root.dataset.sizeValue || !root.dataset.fiSeries || !root.dataset.colorValue) {
      setStatus(root, 'Complete fit, Fi, and color before adding this setup.', 'error');
      return;
    }
    const synced = await waitForNative(root, 3500);
    if (!synced) {
      setStatus(root, 'Eurus is still resolving this exact variant. Re-select the last choice and try again.', 'error');
      return;
    }
    const collarId = nativeVariantId(root);
    if (!collarId) {
      setStatus(root, 'That exact collar combination is not currently available.', 'error');
      return;
    }
    const chainChoice = window.EDGMartingaleChainOption
      ? await window.EDGMartingaleChainOption.resolve(root.dataset.fiSeries, collarId, 1)
      : { label: 'Standard webbing loop — included', item: null };
    if (chainChoice.error) {
      setStatus(root, chainChoice.error, 'error');
      return;
    }

    const neck = Number($(root, '[data-neck]').value);
    const head = Number($(root, '[data-head]').value);
    const nightguard = $(root, '[data-nightguard]');
    const adapterOn = $(root, '[data-add-adapter]');
    const adapterType = $(root, '[data-adapter-type]');
    const adapterVariant = $(root, '[data-adapter-variant]');
    const items = [{
      id: collarId,
      quantity: 1,
      properties: {
        'Dog neck': pretty(neck) + ' in',
        'Widest head': pretty(head) + ' in',
        'Required opening': pretty(required) + ' in',
        'EDG guided size': root.dataset.sizeValue,
        'Fi setup': root.dataset.fiMode === 'add-3' ? 'Add Fi 3+' : 'Existing Fi',
        'Fi collar configuration': root.dataset.fiSeries,
        'Color': root.dataset.colorValue,
        'Martingale loop': chainChoice.label,
        'NightGuard Reflective Edge': nightguard && nightguard.checked ? 'Yes' : 'No',
        'Adapter added': adapterOn && adapterOn.checked ? 'Yes' : 'No',
        '_EDG Config Version': 'guided-martingale-v1',
        '_EDG Entry Path': isFiReferral() ? 'Fi referral' : 'General EDG'
      }
    }];
    const parent = root.dataset.productTitle || 'FI Martingale Collar';
    if (chainChoice.item) items.push(chainChoice.item);

    if (nightguard && nightguard.checked && Number(root.dataset.nightguardVariant)) {
      items.push({ id: Number(root.dataset.nightguardVariant), quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Upgrade': 'NightGuard Reflective Edge' } });
    }
    if (root.dataset.fiMode === 'add-3' && Number(root.dataset.fi3Variant)) {
      items.push({ id: Number(root.dataset.fi3Variant), quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Setup': 'Fi 3+ module' } });
    }
    if (adapterOn && adapterOn.checked) {
      const adapterId = Number(adapterVariant && adapterVariant.value);
      if (!adapterType.value || !adapterId) {
        setStatus(root, 'Choose the adapter type and fit, or turn the adapter option off.', 'error');
        return;
      }
      items.push({ id: adapterId, quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Collar Bundle': 'Eligible' } });
    }

    const button = $(root, '[data-add-setup]');
    button.disabled = true;
    button.textContent = 'Adding setup…';
    try {
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Shopify could not add this setup.');
      setStatus(root, 'Setup added. Opening cart…');
      location.assign(base + 'cart');
    } catch (e) {
      setStatus(root, e.message || 'Something prevented this setup from being added.', 'error');
      button.disabled = false;
      button.textContent = 'Add this setup to cart';
    }
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    if (isFiReferral()) $(root, '[data-fi-referral]').hidden = false;

    $$(root, '[data-neck], [data-head]').forEach(input => input.addEventListener('input', () => updateFit(root)));

    $$(root, '[data-size-choice]').forEach(button => button.addEventListener('click', () => {
      selectChoice(button, $(root, '[data-size-choices]'));
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) {
        setStatus(root, 'We could not apply that size to the Eurus selector.', 'error');
        return;
      }
      root.dataset.sizeValue = button.dataset.nativeValue;
      $(root, '[data-step-summary="fit"]').textContent = pretty(opening(root)) + ' in opening · ' + button.dataset.nativeValue;
      setStep(root, 'fit', 'complete');
      setStep(root, 'fi', 'active');
      setStep(root, 'finish', 'locked');
      setStep(root, 'color', 'locked');
      focusActiveStep(root);
    }));

    $$(root, '[data-fi-intent-choice]').forEach(button => button.addEventListener('click', () => showFiIntent(root, button.dataset.fiIntentChoice, button)));
    $$(root, '[data-fi-series]').forEach(button => button.addEventListener('click', () => completeFi(root, button, 'own')));
    $$(root, '[data-fi-new-series]').forEach(button => button.addEventListener('click', () => completeFi(root, button, 'add-3')));

    $(root, '[data-color-select]').addEventListener('change', event => {
      const option = event.target.options[event.target.selectedIndex];
      if (!event.target.value) return;
      if (!applyNative(option.dataset.nativeOption || 'color', event.target.value)) {
        setStatus(root, 'We could not apply that color to the current Eurus selector.', 'error');
        return;
      }
      root.dataset.colorValue = event.target.value;
      root.dataset.preferredColor = event.target.value;
      $(root, '[data-step-summary="color"]').textContent = event.target.value;
      setStep(root, 'color', 'complete');
      updateReview(root);
      $(root, '[data-review]').hidden = false;
      $(root, '[data-review]').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    const nightguard = $(root, '[data-nightguard]');
    if (nightguard) nightguard.addEventListener('change', () => updateReview(root));
    const adapterToggle = $(root, '[data-add-adapter]');
    if (adapterToggle) adapterToggle.addEventListener('change', () => {
      $(root, '[data-adapter-panel]').hidden = !adapterToggle.checked;
      updateReview(root);
    });
    $(root, '[data-adapter-type]').addEventListener('change', () => loadAdapter(root));
    $(root, '[data-adapter-variant]').addEventListener('change', () => updateReview(root));

    $(root, '[data-finish-review]').addEventListener('click', () => {
      $(root, '[data-step-summary="finish"]').textContent = 'Options selected';
      setStep(root, 'finish', 'complete');
      setStep(root, 'color', 'active');
      setTimeout(() => { syncColorAvailability(root); reuseChosenColor(root, window.EDGBuildSession); }, 650);
    });

    $$(root, '[data-edit-step]').forEach(button => button.addEventListener('click', () => {
      if (button.disabled) return;
      activateStep(root, button.dataset.editStep);
    }));

    $(root, '[data-add-setup]').addEventListener('click', () => addSetup(root));
    document.addEventListener('eurus:variant:change', () => syncColorAvailability(root));
  }

  function initAll(scope) { $$(scope || document, '[data-edg-guide]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-home-guided-handoff"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function addGuided(url){if(!url||url.indexOf('edg_guided=1')>=0)return url;if(url.indexOf('/collections/')!==0)return url;return url+(url.indexOf('?')>=0?'&':'?')+'edg_guided=1';}
  function fix(){var root=document.querySelector('[data-edg-guide-root]');if(!root)return;var map={'standard-collars':'/collections/collars','fi-collars':'/collections/fi-collars','all-adapters':'/collections/fi-adapter-series'};Object.keys(map).forEach(function(key){var link=root.querySelector('[data-edg-result-card="'+key+'"]');if(link)link.setAttribute('href',addGuided(map[key]));});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();document.addEventListener('shopify:section:load',fix);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-k9-department"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const strings = JSON.parse(root.querySelector('[data-k9-strings]').textContent);
    const intent = root.querySelector('[data-k9-intent]');
    root.querySelector('[data-k9-print]').addEventListener('click', () => window.print());
    if (!intent) return;
    const lines = root.querySelector('[data-k9-lines]');
    const template = lines.firstElementChild.cloneNode(true);
    const products = new Map(Array.from(root.querySelectorAll('[data-product]'), (card) => [card.dataset.product, {price: Number(card.dataset.price), title: card.dataset.title}]));
    let nextId = 1;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD'});
    const updateEstimate = () => {
      let total = 0;
      let selected = 0;
      let pending = false;
      lines.querySelectorAll('[data-k9-line]').forEach((line) => {
        const product = products.get(line.querySelector('[data-field="adapter"]').value);
        const quantityInput = line.querySelector('[data-field="qty"]');
        const qty = Number(quantityInput.value);
        if (product && Number.isInteger(qty) && qty > 0) {total += product.price * qty; selected += 1;} else {pending = true;}
      });
      const note = selected ? `${pending ? strings.estimate_pending + ' ' : ''}${strings.estimate_note}` : strings.estimate_empty;
      root.querySelector('[data-k9-estimate]').textContent = selected ? money.format(total / 100) : '—';
      root.querySelector('[data-k9-estimate-note]').textContent = note;
      root.querySelector('[data-k9-total-field]').value = selected ? money.format(total / 100) + ' USD. ' + note : strings.estimate_empty;
    };
    const updateLine = (line) => {
      const model = line.querySelector('[data-field="model"]').value;
      const gear = line.querySelector('[data-field="gear"]').value;
      const select = line.querySelector('[data-field="adapter"]');
      const normalMount = gear === 'collar' || gear === 'harness';
      const allowed = {behavior: model === '3plus' && gear === 'collar', compact: ['2','3','3plus'].includes(model) && normalMount, mini: model === 'mini' && normalMount};
      Array.from(select.options).forEach((option) => {
        const enabled = option.value === 'unsure' || Boolean(allowed[option.value]);
        option.hidden = !enabled;
        option.disabled = !enabled;
      });
      if (select.selectedOptions[0]?.disabled) select.value = 'unsure';
      line.querySelector('[data-fit-hint]').textContent = model === 'ultra' ? strings.ultra_hint : gear === 'other' ? strings.custom_hint : model === 'unsure' || gear === 'unsure' ? strings.model_hint : strings.fit_ready;
      updateEstimate();
    };
    const renumber = () => {
      const items = Array.from(lines.children);
      items.forEach((line, index) => {
        line.querySelector('[data-line-title]').textContent = `${strings.setup} ${index + 1}`;
        const remove = line.querySelector('[data-remove]');
        remove.hidden = items.length === 1;
        remove.setAttribute('aria-label', `${remove.textContent.trim()} ${strings.setup} ${index + 1}`);
        line.querySelectorAll('[data-field]').forEach((field) => {field.name = `contact[Setup ${index + 1} - ${field.dataset.field}]`;});
      });
    };
    const setIntent = () => {
      const mode = intent.value;
      root.querySelector('[data-k9-title]').textContent = strings[`form_${mode}_title`];
      root.querySelector('[data-k9-description]').textContent = strings[`form_${mode}_description`];
      root.querySelector('[data-k9-submit]').textContent = strings[`submit_${mode}`];
      root.querySelectorAll('[data-intents]').forEach((fieldset) => {
        const enabled = fieldset.dataset.intents.split(' ').includes(mode);
        fieldset.hidden = !enabled;
        fieldset.disabled = !enabled;
        fieldset.querySelectorAll('[data-required]').forEach((field) => {field.required = enabled;});
      });
      root.querySelector('[data-k9-estimate-wrap]').hidden = mode === 'help';
      root.querySelector('[data-k9-total-field]').disabled = mode === 'help';
      lines.querySelectorAll('[data-field="qty"]').forEach((field) => {field.required = mode !== 'help';});
    };
    root.querySelectorAll('[data-intent-link]').forEach((link) => link.addEventListener('click', () => {
      intent.value = link.dataset.intentLink;
      setIntent();
      root.querySelector('[data-k9-title]').focus({preventScroll:true});
    }));
    intent.addEventListener('change', setIntent);
    lines.addEventListener('change', (event) => {const line = event.target.closest('[data-k9-line]'); if (line) updateLine(line);});
    lines.addEventListener('input', updateEstimate);
    lines.addEventListener('click', (event) => {
      const button = event.target.closest('[data-remove]');
      if (!button || lines.children.length < 2) return;
      button.closest('[data-k9-line]').remove(); renumber(); updateEstimate(); root.querySelector('[data-k9-add]').focus();
    });
    root.querySelector('[data-k9-add]').addEventListener('click', () => {
      const line = template.cloneNode(true);
      nextId += 1;
      line.querySelectorAll('[id]').forEach((field) => {
        const oldId = field.id;
        field.id = oldId.replace(/-1$/, `-${nextId}`);
        const label = line.querySelector(`label[for="${oldId}"]`);
        if (label) label.htmlFor = field.id;
      });
      lines.appendChild(line); renumber(); updateLine(line); setIntent(); line.querySelector('select').focus();
    });
    lines.querySelectorAll('[data-k9-line]').forEach(updateLine);
    renumber(); setIntent();
  };
  document.querySelectorAll('[data-k9-root]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-k9-root]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-measure-help"]) return;
  try {
    
(function () {
  function closeGuide(dialog, trigger, focusInput) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('edg-measure-help-open');
    window.setTimeout(function () {
      if (focusInput) {
        const guide = document.querySelector('[data-edg-guide]');
        const input = guide && guide.querySelector('[data-step="fit"] [data-neck]');
        if (input) {
          input.focus({ preventScroll: true });
          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      if (trigger) trigger.focus({ preventScroll: true });
    }, 30);
  }

  function initMeasureHelp(section) {
    if (!section || section.dataset.edgMeasureInitialized === 'true') return;
    const guide = document.querySelector('[data-edg-guide]');
    const fit = guide && guide.querySelector('[data-step="fit"] .edg-guide__body');
    const lead = fit && fit.querySelector('.edg-guide__lead');
    const dialog = section.querySelector('[data-edg-measure-dialog]');
    if (!guide || !fit || !lead || !dialog) return;

    section.dataset.edgMeasureInitialized = 'true';

    let prompt = guide.querySelector('[data-edg-measure-prompt]');
    if (!prompt) {
      prompt = document.createElement('div');
      prompt.className = 'edg-measure-help__prompt';
      prompt.dataset.edgMeasurePrompt = 'true';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'edg-measure-help__trigger';
      trigger.dataset.edgMeasureTrigger = 'true';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.innerHTML = '<span class="edg-measure-help__trigger-icon" aria-hidden="true">?</span><span>How do I measure?</span>';

      const note = document.createElement('span');
      note.className = 'edg-measure-help__prompt-text';
      note.textContent = 'See exactly where the measuring tape should sit.';

      prompt.appendChild(trigger);
      prompt.appendChild(note);
      lead.insertAdjacentElement('afterend', prompt);
    }

    const trigger = prompt.querySelector('[data-edg-measure-trigger]');
    const closeButton = dialog.querySelector('[data-edg-measure-close]');
    const doneButton = dialog.querySelector('[data-edg-measure-done]');

    function openGuide() {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('edg-measure-help-open');
      window.setTimeout(function () {
        if (closeButton) closeButton.focus({ preventScroll: true });
      }, 20);
    }

    trigger.addEventListener('click', openGuide);
    if (closeButton) closeButton.addEventListener('click', function () { closeGuide(dialog, trigger, false); });
    if (doneButton) doneButton.addEventListener('click', function () { closeGuide(dialog, trigger, true); });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeGuide(dialog, trigger, false);
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('edg-measure-help-open');
    });
    dialog.addEventListener('cancel', function () {
      document.documentElement.classList.remove('edg-measure-help-open');
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-edg-measure-help]').forEach(initMeasureHelp);
  }

  function boot() {
    initAll(document);
    window.setTimeout(function () { initAll(document); }, 250);
    window.setTimeout(function () { initAll(document); }, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    window.setTimeout(function () { initAll(document); }, 100);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-product-identity"]) return;
  try {
    
(function(){
  function initEngraving(){
    document.querySelectorAll('[data-edg-engraving]').forEach(function(panel){
      // The product form's engraving block owns validation and line-item properties.
      if(document.querySelector('.edg-tag-engraving')){ panel.remove(); return; }
      if(panel.dataset.edgInitialized==='1') return;
      var forms=[].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function(form){
        var button=form.querySelector('button[name="add"]');
        return button && !form.closest('#QuickView') && (form.offsetWidth || form.offsetHeight);
      });
      var form=forms[0];
      if(!form) return;
      var button=form.querySelector('button[name="add"]');
      if(!button) return;
      form.insertBefore(panel,button);
      panel.hidden=false;
      panel.dataset.edgInitialized='1';
      var first=panel.querySelector('input[required]');
      var error=panel.querySelector('[data-edg-engraving-error]');
      function validate(event){
        if(first && !first.value.trim()){
          event.preventDefault();
          event.stopImmediatePropagation();
          error.hidden=false;
          first.setAttribute('aria-invalid','true');
          first.focus();
          return false;
        }
        if(error) error.hidden=true;
        if(first) first.removeAttribute('aria-invalid');
        return true;
      }
      button.addEventListener('click',validate,true);
      form.addEventListener('submit',validate,true);
      if(first) first.addEventListener('input',function(){
        if(first.value.trim()){error.hidden=true;first.removeAttribute('aria-invalid')}
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initEngraving);
  else initEngraving();
  document.addEventListener('shopify:section:load',initEngraving);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-product-intelligence"] && !Shopify.designMode) return;
  try {
    
(function () {
  const LABELS = {
    none: 'No Fi — collar only',
    'own-3': 'Using your Fi 3+',
    'own-mini': 'Using your Fi Mini',
    'add-3': 'Add Fi 3+',
    'add-mini': 'Add Fi Mini'
  };

  function money(cents) {
    if (typeof cents !== 'number') return '';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
  }

  function isFiReferral() {
    const params = new URLSearchParams(window.location.search);
    const source = (params.get('utm_source') || params.get('source') || '').toLowerCase();
    const referrer = (document.referrer || '').toLowerCase();
    return source === 'fi' || source.includes('tryfi') || source.includes('fi-maker') || source.includes('fimaker') || referrer.includes('tryfi.com');
  }

  function nativeVariantId(root) {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    const usable = forms.find(form => !root.contains(form) && form.querySelector('[name="id"]'));
    const field = usable && usable.querySelector('[name="id"]');
    return field && field.value ? Number(field.value) : null;
  }

  async function productJson(handle) {
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to load adapter options.');
    return response.json();
  }

  function selectedFi(root) {
    const checked = root.querySelector('[data-fi-choices] input:checked');
    return checked ? checked.value : 'none';
  }

  function opening(root) {
    const neck = Number(root.querySelector('[data-neck-measure]').value);
    const head = Number(root.querySelector('[data-head-measure]').value);
    if (!neck || !head || neck <= 0 || head <= 0) return null;
    return Math.max(neck, head);
  }

  function prettyNumber(value) {
    return Number(value.toFixed(3)).toString();
  }

  function filterAdapters(root) {
    const fi = selectedFi(root);
    const family = fi.includes('mini') ? 'mini' : fi.includes('3') ? '3' : 'all';
    const select = root.querySelector('[data-adapter-type]');
    let currentStillVisible = select.value === '';
    Array.from(select.options).forEach(option => {
      if (!option.dataset.family) return;
      const show = family === 'all' || option.dataset.family === family;
      option.hidden = !show;
      option.disabled = !show;
      if (show && option.value === select.value) currentStillVisible = true;
    });
    if (!currentStillVisible) {
      select.value = '';
      const wrap = root.querySelector('[data-adapter-variant-wrap]');
      wrap.hidden = true;
      root.querySelector('[data-adapter-variant]').innerHTML = '';
    }
  }

  async function loadAdapterVariants(root) {
    const typeSelect = root.querySelector('[data-adapter-type]');
    const variantWrap = root.querySelector('[data-adapter-variant-wrap]');
    const variantSelect = root.querySelector('[data-adapter-variant]');
    const option = typeSelect.options[typeSelect.selectedIndex];
    const handle = option && option.dataset.handle;
    variantSelect.innerHTML = '';
    if (!handle) {
      variantWrap.hidden = true;
      updateReview(root);
      return;
    }

    variantWrap.hidden = false;
    variantSelect.innerHTML = '<option>Loading…</option>';
    try {
      const data = await productJson(handle);
      variantSelect.innerHTML = '';
      data.variants.forEach(variant => {
        const choice = document.createElement('option');
        choice.value = variant.id;
        choice.textContent = variant.title + (variant.price != null ? ' — ' + money(variant.price) : '');
        choice.disabled = variant.available === false;
        choice.dataset.title = variant.title;
        variantSelect.appendChild(choice);
      });
      if (!variantSelect.options.length) throw new Error('No adapter variants are available.');
      updateReview(root);
    } catch (error) {
      variantSelect.innerHTML = '';
      const choice = document.createElement('option');
      choice.textContent = 'Could not load adapter options';
      choice.disabled = true;
      variantSelect.appendChild(choice);
      setStatus(root, error.message || 'Unable to load adapter options.', 'error');
    }
  }

  function updateOpening(root) {
    const result = root.querySelector('[data-opening-result]');
    const required = opening(root);
    result.textContent = required ? prettyNumber(required) + ' in minimum opening' : 'Enter both measurements';
    updateReview(root);
  }

  function updateReview(root) {
    const required = opening(root);
    const fi = selectedFi(root);
    const nightguard = root.querySelector('[data-nightguard]');
    const adapterType = root.querySelector('[data-adapter-type]');
    const adapterVariant = root.querySelector('[data-adapter-variant]');

    root.querySelector('[data-review-fit]').textContent = required ? prettyNumber(required) + ' in required opening' : 'Enter neck + head measurements';
    root.querySelector('[data-review-fi]').textContent = LABELS[fi] || 'No Fi — collar only';
    root.querySelector('[data-review-built]').textContent = nightguard && nightguard.checked ? 'NightGuard Reflective Edge' : 'Standard build';

    let gear = [];
    if (fi === 'add-3') gear.push(root.dataset.fi3Title || 'Fi 3+');
    if (fi === 'add-mini') gear.push(root.dataset.fiminiTitle || 'Fi Mini');
    if (adapterType.value) {
      const typeLabel = adapterType.options[adapterType.selectedIndex].textContent.split(' — ')[0];
      const variantLabel = adapterVariant && adapterVariant.value && adapterVariant.options[adapterVariant.selectedIndex] ? adapterVariant.options[adapterVariant.selectedIndex].dataset.title : '';
      gear.push(variantLabel ? typeLabel + ' / ' + variantLabel : typeLabel);
    }
    root.querySelector('[data-review-gear]').textContent = gear.length ? gear.join(' + ') : 'None';
  }

  function setStatus(root, message, state) {
    const node = root.querySelector('[data-builder-status]');
    node.textContent = message || '';
    if (state) node.dataset.state = state;
    else delete node.dataset.state;
  }

  async function addSetup(root) {
    setStatus(root, '', '');
    const neck = Number(root.querySelector('[data-neck-measure]').value);
    const head = Number(root.querySelector('[data-head-measure]').value);
    const required = opening(root);
    if (!required) {
      setStatus(root, 'Enter both neck and widest-head measurements before adding this martingale.', 'error');
      root.querySelector('[data-neck-measure]').focus();
      return;
    }

    const collarVariantId = nativeVariantId(root);
    if (!collarVariantId) {
      setStatus(root, 'Choose your collar size, color, and hardware in the product options above first.', 'error');
      return;
    }

    const fi = selectedFi(root);
    const nightguard = root.querySelector('[data-nightguard]');
    const adapterType = root.querySelector('[data-adapter-type]');
    const adapterVariant = root.querySelector('[data-adapter-variant]');
    const entryPath = isFiReferral() ? 'Fi referral' : 'General EDG';

    const collarProperties = {
      'Dog neck': prettyNumber(neck) + ' in',
      'Widest head': prettyNumber(head) + ' in',
      'Required opening': prettyNumber(required) + ' in',
      'Fi setup': LABELS[fi] || 'No Fi — collar only',
      'NightGuard Reflective Edge': nightguard && nightguard.checked ? 'Yes' : 'No',
      'Adapter added': adapterType.value ? 'Yes' : 'No',
      '_EDG Config Version': 'eurus-v1',
      '_EDG Entry Path': entryPath
    };

    const items = [{ id: collarVariantId, quantity: 1, properties: collarProperties }];
    const parent = root.dataset.productTitle || 'EDG collar';

    if (nightguard && nightguard.checked) {
      const nightguardId = Number(root.dataset.nightguardVariant);
      if (nightguardId) items.push({ id: nightguardId, quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Upgrade': 'NightGuard Reflective Edge' } });
    }

    if (fi === 'add-3') {
      const moduleId = Number(root.dataset.fi3Variant);
      if (!moduleId) { setStatus(root, 'The Fi 3+ module is not available for this configuration.', 'error'); return; }
      items.push({ id: moduleId, quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Setup': 'Fi module' } });
    }
    if (fi === 'add-mini') {
      const moduleId = Number(root.dataset.fiminiVariant);
      if (!moduleId) { setStatus(root, 'The Fi Mini module is not available for this configuration.', 'error'); return; }
      items.push({ id: moduleId, quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Setup': 'Fi module' } });
    }

    if (adapterType.value) {
      const adapterId = Number(adapterVariant.value);
      if (!adapterId) { setStatus(root, 'Choose the adapter fit and hardware before adding your setup.', 'error'); return; }
      items.push({ id: adapterId, quantity: 1, properties: { '_EDG Bundle Parent': parent, '_EDG Collar Bundle': 'Eligible' } });
    }

    const button = root.querySelector('[data-add-setup]');
    button.disabled = true;
    button.textContent = 'Adding setup…';
    setStatus(root, 'Adding your configured setup…');

    try {
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Shopify could not add this setup.');
      setStatus(root, 'Setup added. Opening cart…');
      window.location.assign(base + 'cart');
    } catch (error) {
      setStatus(root, error.message || 'Something prevented this setup from being added.', 'error');
      button.disabled = false;
      button.textContent = 'Add complete setup to cart';
    }
  }

  function init(root) {
    if (!root || root.dataset.edgInitialized === 'true') return;
    root.dataset.edgInitialized = 'true';

    if (isFiReferral()) {
      const banner = root.querySelector('[data-fi-referral-banner]');
      if (banner) banner.hidden = false;
    }

    root.querySelectorAll('[data-neck-measure], [data-head-measure]').forEach(input => input.addEventListener('input', () => updateOpening(root)));
    root.querySelectorAll('[data-fi-choices] input').forEach(input => input.addEventListener('change', () => { filterAdapters(root); updateReview(root); }));
    const nightguard = root.querySelector('[data-nightguard]');
    if (nightguard) nightguard.addEventListener('change', () => updateReview(root));
    root.querySelector('[data-adapter-type]').addEventListener('change', () => loadAdapterVariants(root));
    root.querySelector('[data-adapter-variant]').addEventListener('change', () => updateReview(root));
    root.querySelector('[data-add-setup]').addEventListener('click', () => addSetup(root));
    document.addEventListener('change', event => { if (!root.contains(event.target)) updateReview(root); });

    filterAdapters(root);
    updateOpening(root);
    updateReview(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-edg-builder]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-product-workspace"]) return;
  try {
    
(function () {
  const STEP_LABELS = {
    fit: '1 of 4 · Fit',
    fi: '2 of 4 · Fi',
    color: '3 of 4 · Color',
    finish: '4 of 4 · Finish'
  };

  function sectionWrapper(node) {
    let current = node;
    while (current && current !== document.body) {
      if (current.id && current.id.indexOf('shopify-section-') === 0) return current;
      current = current.parentElement;
    }
    return null;
  }

  function mediaCount(node) {
    if (!node || !node.querySelectorAll) return 0;
    return node.querySelectorAll('img, video, model-viewer, [data-media-id]').length;
  }

  function exposeMediaOnly(mainSection) {
    if (!mainSection || mainSection.dataset.edgMediaPrepared === 'true') return;
    const picker = mainSection.querySelector('.variant-selects-main');
    if (!picker) return;

    mainSection.dataset.edgMediaPrepared = 'true';
    mainSection.classList.add('edg-native-product-shell');

    let branch = picker;
    let found = null;

    while (branch && branch.parentElement && branch.parentElement !== mainSection) {
      const parent = branch.parentElement;
      const siblings = Array.from(parent.children).filter(child => child !== branch);
      const mediaSibling = siblings
        .map(child => ({ child: child, count: mediaCount(child) }))
        .filter(item => item.count > 0 && !item.child.querySelector('.variant-selects-main'))
        .sort((a, b) => b.count - a.count)[0];

      if (mediaSibling) {
        found = { grid: parent, details: branch, media: mediaSibling.child };
        break;
      }
      branch = parent;
    }

    if (found) {
      found.grid.classList.add('edg-native-product-grid');
      found.details.classList.add('edg-native-details-column');
      found.media.classList.add('edg-native-media-column');
      found.details.style.setProperty('display', 'none', 'important');
      found.grid.style.setProperty('display', 'block', 'important');
      found.media.style.setProperty('width', '100%', 'important');
      found.media.style.setProperty('max-width', 'none', 'important');
    }
  }

  function syncMobileBar(guide, bar) {
    if (!guide || !bar) return;

    const review = guide.querySelector('[data-review]');
    const addProxy = bar.querySelector('[data-edg-mobile-add]');
    const label = bar.querySelector('[data-edg-mobile-step]');
    const reviewVisible = review && !review.hidden;

    if (reviewVisible) {
      label.textContent = 'Review · Your build';
      addProxy.hidden = false;
    } else {
      const active = guide.querySelector('[data-step].is-active');
      const key = active && active.dataset.step;
      label.textContent = STEP_LABELS[key] || 'Build your martingale';
      addProxy.hidden = true;
    }

    bar.hidden = false;
  }

  function installMobileBar(guide, bar) {
    if (!guide || !bar || bar.dataset.edgInstalled === 'true') return;
    bar.dataset.edgInstalled = 'true';

    const addProxy = bar.querySelector('[data-edg-mobile-add]');
    addProxy.addEventListener('click', function () {
      const realAdd = guide.querySelector('[data-add-setup]');
      if (realAdd && !realAdd.disabled) realAdd.click();
    });

    const observer = new MutationObserver(function () {
      syncMobileBar(guide, bar);
    });
    observer.observe(guide, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled']
    });

    syncMobileBar(guide, bar);
  }

  function buildWorkspace() {
    if (document.documentElement.classList.contains('edg-direct-purchase-active')) return;
    const marker = document.querySelector('[data-edg-pdp-workspace-marker]');
    const workspace = document.querySelector('[data-edg-pdp-workspace]');
    if (!marker || !workspace || workspace.dataset.edgBuilt === 'true') return;

    const workspaceSection = sectionWrapper(marker);
    const picker = document.querySelector('.theme-template-suffix-edg-fi-martingale .variant-selects-main');
    const guide = document.querySelector('[data-edg-guide]');
    const identity = document.querySelector('[data-edg-product-identity]');
    const mainSection = sectionWrapper(picker);
    const guideSection = sectionWrapper(guide);
    const identitySection = sectionWrapper(identity);
    const mediaSlot = workspace.querySelector('[data-edg-media-slot]');
    const configSlot = workspace.querySelector('[data-edg-config-slot]');
    const mobileBar = document.querySelector('[data-edg-mobile-stepbar]');

    if (!workspaceSection || !mainSection || !guideSection || !identitySection || !mediaSlot || !configSlot) return;

    workspace.dataset.edgBuilt = 'true';

    if (mainSection.parentNode) {
      mainSection.parentNode.insertBefore(workspaceSection, mainSection);
    }

    exposeMediaOnly(mainSection);
    mediaSlot.appendChild(mainSection);
    configSlot.appendChild(identitySection);
    configSlot.appendChild(guideSection);

    installMobileBar(guide, mobileBar);
  }

  function init() {
    buildWorkspace();
    window.setTimeout(buildWorkspace, 250);
    window.setTimeout(buildWorkspace, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    const workspace = document.querySelector('[data-edg-pdp-workspace]');
    if (workspace) delete workspace.dataset.edgBuilt;
    init();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-signature-canvas-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  const $=(r,s)=>r.querySelector(s),$$=(r,s)=>Array.from(r.querySelectorAll(s));
  const pretty=n=>Number(Number(n).toFixed(3)).toString();
  const show=(el,yes)=>{if(el)el.hidden=!yes};
  const text=(root,sel,value)=>{const el=$(root,sel);if(el)el.textContent=value||''};
  function fiWebbingSummary(root, value, width) {
    const model = String(value || '').replace(/\s*[-–—]\s*(?:3\/4|1)\s*inch\b/ig, '').trim();
    return [model, width ? (root.dataset.webbingLabel || '[width]').replace('[width]', width) : ''].filter(Boolean).join(' · ');
  }

  function nativeContainer(handle){const selector='[data-option-name="'+handle+'"]';return document.querySelector('.variant-selects-main '+selector)||document.querySelector(selector)}
  function applyNative(handle,value){const c=nativeContainer(handle);if(!c)return false;const radio=Array.from(c.querySelectorAll('input[type="radio"]')).find(el=>el.value===value);if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));return true}const select=c.querySelector('select');if(!select)return false;const index=Array.from(select.options).findIndex(o=>o.value===value||o.textContent.trim()===value);if(index<0)return false;select.selectedIndex=index;select.dispatchEvent(new Event('change',{bubbles:true}));return true}
  function nativeSelected(handle){const c=nativeContainer(handle);if(!c)return'';const radio=c.querySelector('input[type="radio"]:checked');if(radio)return radio.value;const select=c.querySelector('select');return select?select.value:''}
  function nativeVariantId(root){const forms=Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(f=>!root.contains(f));const preferred=forms.find(f=>(f.getAttribute('id')||'').indexOf('product-form-')===0&&f.querySelector('input[name="id"]'))||forms.find(f=>f.querySelector('input[name="id"]'));const input=preferred&&preferred.querySelector('input[name="id"]');return input&&input.value?Number(input.value):null}
  function parseRange(label){const m=String(label||'').match(/([0-9]+(?:\.[0-9]+)?)\s*["”]?\s*[-–]\s*([0-9]+(?:\.[0-9]+)?)\s*["”]?/);return m?{min:Number(m[1]),max:Number(m[2])}:null}
  function recommend(root,neck){const buttons=$$(root,'[data-size-choice]');const matches=buttons.map(button=>({button,range:parseRange(button.dataset.nativeValue)})).filter(x=>x.range&&neck>=x.range.min&&neck<=x.range.max).sort((a,b)=>(b.range.min-a.range.min)||(b.range.max-a.range.max));if(matches.length)return{button:matches[0].button,overlap:matches.length>1,custom:false};const custom=buttons.find(b=>/custom/i.test(b.dataset.nativeValue||''));return custom?{button:custom,overlap:false,custom:true}:null}
  function setStep(root,key,state){const step=$(root,'[data-step="'+key+'"]');if(!step)return;step.classList.remove('is-active','is-complete','is-locked');step.classList.add('is-'+state);const header=$(step,'[data-edit-step]');if(header){header.disabled=state==='locked';header.setAttribute('aria-expanded',state==='active'?'true':'false')}const progress=$(root,'[data-progress="'+key+'"]');if(progress){progress.classList.toggle('is-active',state==='active');progress.classList.toggle('is-complete',state==='complete')}}
  function order(root){return ['fit','fi','pattern','addons','review']}
  function activate(root,key){const list=order(root),index=list.indexOf(key);list.forEach((name,i)=>setStep(root,name,i<index?'complete':i===index?'active':'locked'))}
  function select(button,container,selector){$$(container,selector).forEach(el=>{const on=el===button;el.classList.toggle('is-selected',on);el.setAttribute('aria-pressed',on?'true':'false')})}
  function status(root,msg,state){const el=$(root,'[data-status]');if(!el)return;el.textContent=msg||'';if(state)el.dataset.state=state;else delete el.dataset.state}
  function fiKind(value){const v=String(value||'').toLowerCase();if(v.includes('mini'))return'mini';if(v.includes('ultra'))return'ultra';if(v==='fi 2'||v.includes('series 2'))return'2';if(v.includes('3'))return'3';return''}
  function nativeFiForSaved(saved){const kind=fiKind(saved);return kind==='2'?'Fi Series 2':kind==='3'?'Fi Series 3 / S3+':''}
  function cleanPattern(value){return String(value||'').replace(/\s*-?\s*1 inch only\s*$/i,'').trim()}
  function updateFit(root,session){if(window.EDGSizing&&window.EDGSizing.update(root,session))return;const neck=Number($(root,'[data-neck]').value),area=$(root,'[data-size-result]');$$(root,'[data-size-choice]').forEach(b=>{b.hidden=true;b.classList.remove('is-selected')});root.dataset.sizeValue='';if(!(neck>0)){show(area,false);save(root,session);return}if(session&&session.saveMeasurement)session.saveMeasurement('neck',pretty(neck));const rec=recommend(root,neck);if(!rec){show(area,false);save(root,session);return}rec.button.hidden=false;show(area,true);text(root,'[data-size-result-label]',rec.button.dataset.nativeValue);text(root,'[data-size-result-note]',rec.custom?'This measurement falls outside the published standard ranges. Choose the custom-size follow-up to continue.':rec.overlap?'This measurement sits in an overlap. EDG recommends the larger matching published size.':'This is the published size range that contains the neck measurement.');save(root,session)}
  function compat(root,dog){if(new URLSearchParams(location.search).has('edg_edit'))dog=null;if(root.dataset.canvasMode!=='fi')return true;const saved=dog&&dog.fiStatus==='yes'?dog.fiSeries:'',kind=fiKind(saved),box=$(root,'[data-compat]'),steps=$(root,'[data-builder-steps]');root.dataset.savedFiSeries=saved||'';if(kind==='mini'){show(box,true);box.innerHTML='<strong>Fi Mini is not integrated into Signature Canvas.</strong><br>Use the Fi Mini Compact Adapter on compatible gear instead. <a href="/products/fi-mini-compact-adapter?edg_guided=1">Continue to Fi Mini Compact Adapter →</a>';show(steps,false);return false}if(kind==='ultra'){show(box,true);box.innerHTML='<strong>Fi Ultra does not currently have an EDG Signature Canvas path.</strong><br>This product will not be configured as compatible.';show(steps,false);return false}return true}
  function prepareFi(root,dog){if(root.dataset.canvasMode!=='fi')return;const saved=dog&&dog.fiStatus==='yes'?dog.fiSeries:'',native=nativeFiForSaved(saved),buttons=$$(root,'[data-fi-choice]');if(native){const b=buttons.find(x=>x.dataset.nativeValue===native);if(b&&applyNative(b.dataset.nativeOption,b.dataset.nativeValue)){select(b,$(root,'[data-fi-choices]'),'[data-fi-choice]');root.dataset.fiValue=b.dataset.nativeValue;text(root,'[data-step-summary="fi"]',fiWebbingSummary(root,saved||b.dataset.nativeValue,'1 inch'));text(root,'[data-fi-question]','Saved Fi setup: '+(saved||b.dataset.nativeValue)+'. You can keep this selection or choose another supported Fi setup.')}}}
  function updateReview(root,session){const dog=session&&session.activeDog?session.activeDog():null,neck=Number($(root,'[data-neck]').value);text(root,'[data-review-dog]',dog&&dog.name?dog.name:'Your dog');text(root,'[data-review-neck]',neck>0?pretty(neck)+' in':'');text(root,'[data-review-size]',root.dataset.sizeValue||'');text(root,'[data-review-fi]',root.dataset.savedFiSeries||root.dataset.fiValue||'');text(root,'[data-review-pattern]',cleanPattern(root.dataset.patternValue||''))}
  function save(root,session){if(!session||!session.saveBuild)return;const neck=Number($(root,'[data-neck]').value);session.saveBuild('signatureCanvas',{mode:root.dataset.canvasMode,productHandle:root.dataset.productHandle||'',neck:neck>0?pretty(neck):'',size:root.dataset.sizeValue||'',width:'1 inch',fiSeries:root.dataset.savedFiSeries||root.dataset.fiValue||'',nativeFiSeries:root.dataset.fiValue||'',pattern:cleanPattern(root.dataset.patternValue||''),nativePattern:root.dataset.patternValue||'',guided:true})}
  function selectionsMatch(root){const sizeOk=nativeSelected(root.dataset.sizeOption)===(root.dataset.sizeValue||''),patternOk=nativeSelected(root.dataset.patternOption)===(root.dataset.patternValue||'');if(root.dataset.canvasMode!=='fi')return sizeOk&&patternOk;return sizeOk&&patternOk&&nativeSelected(root.dataset.fiOption)===(root.dataset.fiValue||'')}
  function waitNative(root,timeout){return new Promise(resolve=>{const start=Date.now();(function check(){if(selectionsMatch(root)&&nativeVariantId(root))return resolve(true);if(Date.now()-start>=timeout)return resolve(false);setTimeout(check,100)})()})}
  async function add(root,session){if(window.EDGSizing&&!window.EDGSizing.validate(root))return;const neck=Number($(root,'[data-neck]').value),isFi=root.dataset.canvasMode==='fi';if((!window.EDGSizing?.isKnown(root)&&!(neck>0))||!root.dataset.sizeValue||!root.dataset.patternValue||(isFi&&!root.dataset.fiValue)){status(root,isFi?'Complete fit, Fi, and pattern before adding this collar.':'Complete fit and pattern before adding this collar.','error');return}const button=$(root,'[data-add-build]');button.disabled=true;status(root,'Checking the selected Signature Canvas…');if(!window.EDGCheckoutIntegrity||!await window.EDGCheckoutIntegrity.waitForExact(root,4000)){button.disabled=false;status(root,'Eurus could not confirm the exact Shopify variant. Re-select the last choice and try again.','error');return}const id=nativeVariantId(root),dog=session&&session.activeDog?session.activeDog():null;const props={'Dog name':dog&&dog.name?dog.name:'','Dog neck':pretty(neck)+' in','EDG guided size':root.dataset.sizeValue,'Size selection':window.EDGSizing?window.EDGSizing.method(root):'Size recommendation','Signature pattern':cleanPattern(root.dataset.patternValue),'_EDG Config Version':isFi?'guided-fi-signature-canvas-v2':'guided-standard-signature-canvas-v1','_EDG Entry Path':'Walkthrough'};if(isFi){props['Fi setup']=root.dataset.savedFiSeries||root.dataset.fiValue;props['Fi collar configuration']=root.dataset.fiValue;props['Collar width']='1 inch'}button.textContent='Adding collar…';try{const base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';await window.EDGBuildEditor.submit(root,window.EDGBuildCommerce.withIdAnchor(root,{id,quantity:1,properties:props}));save(root,session);status(root,'Collar added. Opening cart…');location.assign(base+'cart')}catch(e){button.disabled=false;button.textContent=window.EDGBuildEditor.label(root)||'Add this collar to cart';status(root,e.message||'Something prevented this collar from being added.','error')}}
  function continueConstruction(root,session){if(root.dataset.canvasMode==='fi'&&!root.dataset.fiValue)return false;setStep(root,'fi','complete');setStep(root,'pattern','active');setStep(root,'addons','locked');setStep(root,'review','locked');text(root,'[data-step-summary="fi"]',fiWebbingSummary(root,root.dataset.fiValue,'1 inch'));save(root,session);return true}
  function init(root,session){if(!root||root.dataset.initialized==='true')return;root.dataset.initialized='true';if(window.EDGSizing)window.EDGSizing.mount(root,{fit:()=>updateFit(root,session),review:()=>updateReview(root,session),save:()=>save(root,session),construction:()=>continueConstruction(root,session)});show(root,true);document.documentElement.classList.add('edg-canvas-guided-active');const dog=session&&session.activeDog?session.activeDog():null;if(!compat(root,dog))return;text(root,'[data-builder-title]',root.dataset.layoutTitle);const size=$(root,'[data-size-choice]'),fi=$(root,'[data-fi-choice]'),pat=$(root,'[data-pattern-select] option[data-native-option]');root.dataset.sizeOption=size?size.dataset.nativeOption:'size';root.dataset.fiOption=fi?fi.dataset.nativeOption:'fi-series';root.dataset.patternOption=pat?pat.dataset.nativeOption:(root.dataset.canvasMode==='fi'?'color':'pattern');if(dog&&dog.measurements&&Number(dog.measurements.neck)>0){$(root,'[data-neck]').value=pretty(Number(dog.measurements.neck));updateFit(root,session)}prepareFi(root,dog);$(root,'[data-neck]').addEventListener('input',()=>updateFit(root,session));$$(root,'[data-size-choice]').forEach(button=>button.addEventListener('click',()=>{if(!applyNative(button.dataset.nativeOption,button.dataset.nativeValue)){status(root,'We could not apply that size to the Shopify selector.','error');return}select(button,$(root,'[data-size-choices]'),'[data-size-choice]');root.dataset.sizeValue=button.dataset.nativeValue;text(root,'[data-step-summary="fit"]',pretty(Number($(root,'[data-neck]').value))+' in neck · '+button.dataset.nativeValue);setStep(root,'fit','complete');setStep(root,'fi','active');setStep(root,'pattern','locked');setStep(root,'addons','locked');setStep(root,'review','locked');save(root,session)}));$$(root,'[data-fi-choice]').forEach(button=>button.addEventListener('click',()=>{if(!applyNative(button.dataset.nativeOption,button.dataset.nativeValue)){status(root,'We could not apply that Fi option to the Shopify selector.','error');return}select(button,$(root,'[data-fi-choices]'),'[data-fi-choice]');root.dataset.fiValue=button.dataset.nativeValue;text(root,'[data-step-summary="fi"]',fiWebbingSummary(root,button.dataset.nativeValue,'1 inch'));setStep(root,'fi','active');setStep(root,'pattern','locked');setStep(root,'addons','locked');setStep(root,'review','locked');save(root,session)}));$(root,'[data-pattern-select]').addEventListener('change',event=>{const option=event.target.options[event.target.selectedIndex];if(!event.target.value)return;if(!applyNative(option.dataset.nativeOption||root.dataset.patternOption,event.target.value)){status(root,'We could not apply that pattern to the Shopify selector.','error');return}const patternButton=$$(root,'[data-pattern-choice]').find(button=>button.dataset.nativeValue===event.target.value);if(patternButton)select(patternButton,$(root,'[data-pattern-choices]'),'[data-pattern-choice]');root.dataset.patternValue=event.target.value;text(root,'[data-step-summary="pattern"]',cleanPattern(event.target.value));setStep(root,'pattern','complete');setStep(root,'addons','active');setStep(root,'review','locked');updateReview(root,session);save(root,session)});$$(root,'[data-pattern-choice]').forEach(button=>button.addEventListener('click',()=>{const patternSelect=$(root,'[data-pattern-select]');patternSelect.value=button.dataset.nativeValue;patternSelect.dispatchEvent(new Event('change',{bubbles:true}))}));$$(root,'[data-edit-step]').forEach(button=>button.addEventListener('click',()=>{if(!button.disabled)activate(root,button.dataset.editStep)}));root.addEventListener('edg:fi-selection',event=>{
const choice=event.detail;root.dataset.savedFiSeries='';root.dataset.fiValue='';root.dataset.patternValue='';
const pattern=$(root,'[data-pattern-select]');if(pattern)pattern.value='';
$$(root,'[data-pattern-choice]').forEach(button=>{button.classList.remove('is-selected');button.setAttribute('aria-pressed','false')});
setStep(root,'fi','active');setStep(root,'pattern','locked');setStep(root,'addons','locked');setStep(root,'review','locked');text(root,'[data-step-summary="fi"]',choice.summary);text(root,'[data-step-summary="pattern"]','');choice.applied=true;
if(!choice.value){save(root,session);return}if(!applyNative(choice.option,choice.value)){choice.applied=false;return}
root.dataset.fiOption=choice.option;root.dataset.fiValue=choice.value;save(root,session);document.dispatchEvent(new CustomEvent('eurus:variant:change'));
});$(root,'[data-add-build]').addEventListener('click',()=>add(root,session));save(root,session)}
  function boot(attempt){const root=document.querySelector('[data-edg-canvas-builder]');if(!root)return;const session=window.EDGBuildSession;if((!session||!window.EDGSizing)&&(attempt||0)<50){setTimeout(()=>boot((attempt||0)+1),60);return}init(root,session||null)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(0));else boot(0);document.addEventListener('shopify:section:load',()=>boot(0));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-sizing-overlap-rule"]) return;
  try {
    
(function () {
  function numberFrom(root, selector) {
    var field = root.querySelector(selector);
    return field ? Number(field.value) : 0;
  }

  function measurements(root) {
    return {
      neck: numberFrom(root, '[data-neck]'),
      head: numberFrom(root, '[data-head]')
    };
  }

  function validMeasurements(root) {
    var m = measurements(root);
    return m.neck > 0 && m.head > 0;
  }

  function governingMeasurement(root) {
    var m = measurements(root);
    if (!(m.neck > 0 && m.head > 0)) return null;
    return root.dataset.edgClosure === 'buckle' ? m.neck : Math.max(m.neck, m.head);
  }

  function pretty(value) {
    return Number(Number(value).toFixed(3)).toString();
  }

  function parseRange(label) {
    var match = String(label || '').match(/([0-9]+(?:\.[0-9]+)?)\s*[\-–]\s*([0-9]+(?:\.[0-9]+)?)/);
    if (!match) return null;
    return { min: Number(match[1]), max: Number(match[2]) };
  }

  function clearSizeButton(button) {
    button.hidden = true;
    button.classList.remove('is-selected', 'edg-size-is-recommended');
    var note = button.querySelector('[data-edg-recommended-label]');
    if (note) note.remove();
  }

  function markRecommended(button) {
    button.hidden = false;
    button.classList.add('edg-size-is-recommended');
    if (!button.querySelector('[data-edg-recommended-label]')) {
      var note = document.createElement('small');
      note.setAttribute('data-edg-recommended-label', '');
      note.textContent = 'EDG recommended size';
      button.appendChild(note);
    }
  }

  function ensureClosureUi(root, marker) {
    var existing = root.querySelector('[data-edg-closure-ui]');
    if (existing) return existing;

    var sizeResults = root.querySelector('[data-size-results]');
    if (!sizeResults || !sizeResults.parentNode) return null;

    var wrap = document.createElement('div');
    wrap.className = 'edg-closure-choice';
    wrap.setAttribute('data-edg-closure-ui', '');
    wrap.hidden = true;

    var eyebrow = document.createElement('p');
    eyebrow.className = 'edg-closure-choice__eyebrow';
    eyebrow.textContent = 'Closure';

    var title = document.createElement('h3');
    title.className = 'edg-closure-choice__title';
    title.textContent = 'How should this martingale go on?';

    var help = document.createElement('p');
    help.className = 'edg-closure-choice__help';
    help.textContent = 'This changes which measurement should control the size.';

    var options = document.createElement('div');
    options.className = 'edg-closure-choice__options';

    var slip = document.createElement('button');
    slip.type = 'button';
    slip.className = 'edg-closure-choice__button';
    slip.setAttribute('data-edg-closure-choice', 'slip-over');
    slip.innerHTML = '<strong>Slip over the head</strong><small>No buckle; needs to fit over the widest part of the head.</small>';

    var buckle = document.createElement('button');
    buckle.type = 'button';
    buckle.className = 'edg-closure-choice__button';
    buckle.setAttribute('data-edg-closure-choice', 'buckle');
    var bucklePrice = marker && marker.dataset.bucklePrice ? marker.dataset.bucklePrice : '';
    buckle.innerHTML = '<strong>Open with Tactical Buckle</strong><small>' +
      (bucklePrice ? '+ ' + bucklePrice + ' · ' : '') +
      'Opens to put it on; doesn’t need to pass over the head.</small>';

    options.appendChild(slip);
    options.appendChild(buckle);
    wrap.appendChild(eyebrow);
    wrap.appendChild(title);
    wrap.appendChild(help);
    wrap.appendChild(options);
    sizeResults.parentNode.insertBefore(wrap, sizeResults);

    Array.from(wrap.querySelectorAll('[data-edg-closure-choice]')).forEach(function (button) {
      button.addEventListener('click', function () {
        root.setAttribute('data-edg-closure', button.dataset.edgClosureChoice);
        Array.from(wrap.querySelectorAll('[data-edg-closure-choice]')).forEach(function (other) {
          var selected = other === button;
          other.classList.toggle('is-selected', selected);
          other.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        enforceSizing(root);
        syncReview(root);
      });
    });

    return wrap;
  }

  function enforceSizing(root) {
    var ui = root.querySelector('[data-edg-closure-ui]');
    var sizeResults = root.querySelector('[data-size-results]');
    var sizeQuestion = sizeResults && sizeResults.querySelector('.edg-guide__question');
    var sizeNote = root.querySelector('[data-size-note]');
    var summary = root.querySelector('[data-step-summary="fit"]');
    var buttons = Array.from(root.querySelectorAll('[data-size-choice]'));

    if (ui) ui.hidden = !validMeasurements(root);

    if (!validMeasurements(root) || !root.dataset.edgClosure) {
      if (sizeResults) sizeResults.style.display = 'none';
      return;
    }

    if (sizeResults) sizeResults.style.display = '';
    var required = governingMeasurement(root);
    if (!required || !buttons.length) return;

    var standardMatches = [];
    var customButton = null;

    buttons.forEach(function (button) {
      clearSizeButton(button);
      var label = button.dataset.nativeValue || button.textContent || '';
      var range = parseRange(label);
      if (/custom/i.test(label)) customButton = button;
      if (range && required >= range.min && required <= range.max) {
        standardMatches.push({ button: button, range: range });
      }
    });

    delete root.dataset.sizeValue;

    if (standardMatches.length) {
      standardMatches.sort(function (a, b) {
        if (a.range.min !== b.range.min) return b.range.min - a.range.min;
        return b.range.max - a.range.max;
      });

      var recommended = standardMatches[0];
      markRecommended(recommended.button);
      root.dataset.edgRecommendedSize = recommended.button.dataset.nativeValue || '';

      if (root.dataset.edgClosure === 'buckle') {
        root.dataset.edgSizingRule = 'Buckle opens fully; neck measurement drives size; larger size wins overlap';
        if (sizeQuestion) sizeQuestion.textContent = 'EDG recommended size · buckle';
        if (sizeNote) {
          sizeNote.textContent = 'Because the Tactical Buckle opens the collar completely, the head measurement does not force a larger size. EDG is sizing this build from the ' + pretty(required) + ' in neck measurement.';
        }
        if (summary) summary.textContent = pretty(required) + ' in neck · buckle sizing · recommendation ready';
      } else {
        root.dataset.edgSizingRule = 'Slip-over; larger of neck/head; larger size wins overlap';
        if (sizeQuestion) sizeQuestion.textContent = 'EDG recommended size · slip-over';
        if (sizeNote) {
          sizeNote.textContent = standardMatches.length > 1
            ? 'Your ' + pretty(required) + ' in required opening falls in overlapping published ranges. EDG recommends the larger matching size.'
            : 'Slip-over sizing uses the larger of the neck and widest-head measurements: ' + pretty(required) + ' in required opening.';
        }
        if (summary) summary.textContent = pretty(required) + ' in opening · slip-over · recommendation ready';
      }
    } else if (customButton) {
      markRecommended(customButton);
      root.dataset.edgRecommendedSize = customButton.dataset.nativeValue || 'Custom';
      root.dataset.edgSizingRule = root.dataset.edgClosure === 'buckle'
        ? 'Buckle; neck outside published standard range; custom review'
        : 'Slip-over; required opening outside published standard range; custom review';
      if (sizeQuestion) sizeQuestion.textContent = 'EDG fit recommendation';
      if (sizeNote) sizeNote.textContent = 'The governing measurement falls outside the published standard range. Custom fit review is the correct next path.';
      if (summary) summary.textContent = pretty(required) + ' in governing measurement · custom review';
    }

    var opening = root.querySelector('[data-opening]');
    if (opening) opening.textContent = pretty(required);
  }

  function syncSizeSummary(root) {
    if (!root.dataset.sizeValue || !root.dataset.edgClosure) return;
    var summary = root.querySelector('[data-step-summary="fit"]');
    var required = governingMeasurement(root);
    if (!summary || !required) return;
    summary.textContent = root.dataset.edgClosure === 'buckle'
      ? pretty(required) + ' in neck · Tactical Buckle · ' + root.dataset.sizeValue
      : pretty(required) + ' in opening · slip-over · ' + root.dataset.sizeValue;
  }

  function ensureReviewRow(root) {
    var review = root.querySelector('[data-review]');
    var list = review && review.querySelector('dl');
    if (!list || list.querySelector('[data-review-closure]')) return;

    var row = document.createElement('div');
    var dt = document.createElement('dt');
    var dd = document.createElement('dd');
    dt.textContent = 'Closure';
    dd.setAttribute('data-review-closure', '');
    row.appendChild(dt);
    row.appendChild(dd);

    var sizeValue = list.querySelector('[data-review-size]');
    var sizeRow = sizeValue && sizeValue.parentElement;
    if (sizeRow && sizeRow.nextSibling) {
      list.insertBefore(row, sizeRow.nextSibling);
    } else {
      list.appendChild(row);
    }
  }

  function syncReview(root) {
    ensureReviewRow(root);
    var closure = root.dataset.edgClosure;
    if (!closure) return;

    var m = measurements(root);
    var required = governingMeasurement(root);
    var closureValue = root.querySelector('[data-review-closure]');
    var fitValue = root.querySelector('[data-review-fit]');
    var builtValue = root.querySelector('[data-review-built]');

    if (closureValue) {
      closureValue.textContent = closure === 'buckle' ? 'Tactical Buckle' : 'Slip-over';
    }

    if (fitValue && required) {
      fitValue.textContent = closure === 'buckle'
        ? pretty(m.neck) + ' in neck used for sizing · ' + pretty(m.head) + ' in head recorded'
        : pretty(required) + ' in required opening';
    }

    if (builtValue) {
      var built = [];
      if (closure === 'buckle') built.push('Tactical Buckle');
      var nightGuard = root.querySelector('[data-nightguard]');
      if (nightGuard && nightGuard.checked) built.push('NightGuard Reflective Edge');
      builtValue.textContent = built.length ? built.join(' · ') : 'Standard slip-over build';
    }
  }

  function installCartBridge(root, marker) {
    if (window.__edgBuckleFetchInstalled) return;
    window.__edgBuckleFetchInstalled = true;

    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
        if (/\/cart\/add\.js(?:\?|$)/.test(url) && init && typeof init.body === 'string') {
          var payload = JSON.parse(init.body);
          var activeRoot = document.querySelector('[data-edg-guide]');
          var closure = activeRoot && activeRoot.dataset.edgClosure;

          if (closure && payload && Array.isArray(payload.items)) {
            var collar = payload.items.find(function (item) {
              return item && item.properties && item.properties['_EDG Config Version'];
            });

            if (collar) {
              collar.properties = collar.properties || {};
              var m = measurements(activeRoot);
              var sizingValue = governingMeasurement(activeRoot);

              collar.properties['Martingale closure'] = closure === 'buckle' ? 'Tactical Buckle' : 'Slip-over';
              collar.properties['EDG sizing basis'] = closure === 'buckle' ? 'Neck only' : 'Larger of neck and widest head';
              collar.properties['EDG sizing measurement'] = sizingValue ? pretty(sizingValue) + ' in' : '';
              collar.properties['_EDG Closure'] = closure;

              if (closure === 'buckle') {
                delete collar.properties['Required opening'];

                var buckleId = marker && marker.dataset.buckleVariantId ? Number(marker.dataset.buckleVariantId) : 0;
                var alreadyAdded = buckleId && payload.items.some(function (item) {
                  return Number(item.id) === buckleId;
                });

                if (buckleId && !alreadyAdded) {
                  payload.items.push({
                    id: buckleId,
                    quantity: 1,
                    properties: {
                      '_EDG Upgrade': 'Tactical Buckle',
                      '_EDG Collar Bundle': String(collar.id),
                      'Built into collar': 'Yes'
                    }
                  });
                }
              }

              init = Object.assign({}, init, { body: JSON.stringify(payload) });
            }
          }
        }
      } catch (error) {
        console.warn('EDG buckle cart bridge skipped:', error);
      }

      return nativeFetch.call(this, input, init);
    };
  }

  function init(root, marker) {
    if (!root || root.dataset.edgBuckleRuleInitialized === 'true') return;
    root.dataset.edgBuckleRuleInitialized = 'true';

    ensureClosureUi(root, marker);
    installCartBridge(root, marker);

    Array.from(root.querySelectorAll('[data-neck], [data-head]')).forEach(function (input) {
      input.addEventListener('input', function () {
        window.setTimeout(function () {
          enforceSizing(root);
          syncReview(root);
        }, 0);
      });
      input.addEventListener('change', function () {
        window.setTimeout(function () {
          enforceSizing(root);
          syncReview(root);
        }, 0);
      });
    });

    Array.from(root.querySelectorAll('[data-size-choice]')).forEach(function (button) {
      button.addEventListener('click', function () {
        window.setTimeout(function () {
          syncSizeSummary(root);
          syncReview(root);
        }, 0);
      });
    });

    var reviewButton = root.querySelector('[data-review-button], [data-finish-review]');
    if (reviewButton) {
      reviewButton.addEventListener('click', function () {
        window.setTimeout(function () { syncReview(root); }, 0);
      });
    }

    var observer = new MutationObserver(function () {
      syncReview(root);
    });
    observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });

    enforceSizing(root);
    syncReview(root);
  }

  function initAll(scope) {
    var marker = document.querySelector('[data-edg-buckle-rule]');
    Array.from((scope || document).querySelectorAll('[data-edg-guide]')).forEach(function (root) {
      init(root, marker);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-tag-type-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__edgTagHoverBound) return;
    window.__edgTagHoverBound = true;

    function prepareCard(card) {
      if (!card || card.dataset.edgHoverPrepared === 'true') return;
      var alternate = card.querySelector('img.image-second-hover');
      if (!alternate) return;

      card.dataset.edgHoverPrepared = 'true';

      function markReady() {
        if (alternate.complete && alternate.naturalWidth > 0) {
          card.classList.add('edg-hover-ready');
        }
      }

      alternate.addEventListener('load', markReady, { once: true });
      alternate.addEventListener('error', function () {
        card.classList.remove('edg-hover-ready');
      }, { once: true });

      alternate.loading = 'eager';
      alternate.fetchPriority = 'low';
      markReady();

      if (!alternate.complete) {
        var source = alternate.currentSrc || alternate.src;
        if (source) {
          var preloader = new Image();
          preloader.decoding = 'async';
          preloader.onload = function () {
            if (!alternate.complete || alternate.naturalWidth === 0) {
              alternate.loading = 'eager';
              alternate.src = source;
            }
            markReady();
          };
          preloader.src = source;
        }
      }
    }

    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            prepareCard(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '240px' })
      : null;

    function observeCards(scope) {
      var cards = (scope || document).querySelectorAll('a.link-product-variant');
      cards.forEach(function (card) {
        if (observer) observer.observe(card);
      });
    }

    document.addEventListener('pointerover', function (event) {
      prepareCard(event.target.closest('a.link-product-variant'));
    }, { passive: true });

    document.addEventListener('focusin', function (event) {
      prepareCard(event.target.closest('a.link-product-variant'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        observeCards(document);
      }, { once: true });
    } else {
      observeCards(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      observeCards(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edg-wizard-focus"]) return;
  try {
    
(function () {
  var previousStep = {
    fi: 'fit',
    color: 'fi',
    finish: 'color'
  };

  function editStep(root, key) {
    var editButton = root.querySelector('[data-edit-step="' + key + '"]');
    if (editButton) {
      editButton.click();
    }
  }

  function addBackButton(root, stepKey, previousKey) {
    var step = root.querySelector('[data-step="' + stepKey + '"]');
    if (!step) return;

    var body = step.querySelector('.edg-guide__body');
    if (!body || body.querySelector('[data-edg-wizard-back]')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'edg-wizard-back';
    button.setAttribute('data-edg-wizard-back', '');
    button.setAttribute('aria-label', 'Go back to the previous choice');
    button.textContent = '← Back';
    button.addEventListener('click', function () {
      editStep(root, previousKey);
    });
    body.prepend(button);
  }

  function addReviewBackButton(root) {
    var review = root.querySelector('[data-review]');
    if (!review || review.querySelector('[data-edg-wizard-review-back]')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'edg-wizard-back';
    button.setAttribute('data-edg-wizard-review-back', '');
    button.setAttribute('aria-label', 'Edit the previous choice');
    button.textContent = '← Edit choices';
    button.addEventListener('click', function () {
      editStep(root, 'finish');
    });
    review.prepend(button);
  }

  function sync(root) {
    Object.keys(previousStep).forEach(function (stepKey) {
      addBackButton(root, stepKey, previousStep[stepKey]);
    });
    addReviewBackButton(root);

    var review = root.querySelector('[data-review]');
    var isReviewing = review && !review.hidden;
    root.classList.toggle('edg-wizard-is-reviewing', Boolean(isReviewing));
  }

  function init(root) {
    if (!root || root.dataset.edgWizardFocusInitialized === 'true') return;
    root.dataset.edgWizardFocusInitialized = 'true';

    sync(root);

    var observer = new MutationObserver(function () {
      sync(root);
    });

    observer.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.edg-guide').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
